/* bios-main.js — the BIOS terminal core.
   Session id, command parser, search, filters, audio cues, product list
   render + pagination, overlay open/close, peek thumbnail, netfield
   integration, /search and /filter routing, and the catalog state machine.
   Asset URLs that used to be interpolated by Liquid (audio cues + the
   base.css preload) are now read from window.__INNOCENCES_ASSETS__, which
   is set inline by sections/main-content.liquid right before this loads. */
(function () {
  'use strict';

  /* ── Session ID ── */
  var SID = sessionStorage.getItem('bios_sid');
  if (!SID) {
    SID = 'SID-' + Date.now().toString(36).toUpperCase().slice(-6) +
          '-' + Math.floor(Math.random() * 0xFFFF).toString(16).toUpperCase().padStart(4, '0');
    sessionStorage.setItem('bios_sid', SID);
  }

  var drum        = document.getElementById('bios-drum');
  var list        = document.getElementById('bios-list');
  var preview     = document.getElementById('bios-preview');
  var clockEl     = document.getElementById('bios-clock');
  var searchEl    = document.getElementById('bios-search');
  var typedEl     = document.getElementById('bios-typed');
  var caretEl     = document.getElementById('bios-caret');
  var cmdLine     = document.getElementById('bios-cmd-line');

  /* ── Finite product list (no clones) ── */
  var origItems = Array.from(list.querySelectorAll('.bios-item'));
  var MID = origItems.length; /* kept for legacy refs that mean "original count" */

  var items = origItems;
  items.forEach(function(item, i) { item.dataset.idx = i; });

  var activeIdx     = 0;
  (function() {
    var _rr = localStorage.getItem('bios_restore');
    if (!_rr) return;
    var _rh = _rr.split(':')[0];
    for (var _ri = 0; _ri < origItems.length; _ri++) {
      if (origItems[_ri].dataset.handle === _rh) { activeIdx = _ri; break; }
    }
  })();
  var hoverItem     = null;
  var hideTimer     = null;
  var scrollAcc     = 0;
  var typingTimer   = null;

  /* ── Pagination ── */
  var PAGE_SIZE      = 4;
  var currentPage    = 0;
  var totalPages     = Math.ceil(items.length / PAGE_SIZE);
  var isTransitioning = false;
  var _pageWheelAcc  = 0;
  var snapTimer     = null;
  var hoverTimers   = {};
  var idleViewTimer = null;
  var prevActiveItem   = null;
  var activeAnimTimer  = null;

  /* ── Touch-device detection ── */
  /* Also published on window so later <script> blocks (initGlitchPopups, MutationObserver,
     tryStart) can read it — they live outside this IIFE's closure. */
  var isTouchDevice = window.isTouchDevice = (navigator.maxTouchPoints > 0) ||
                      window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  /* ── Cursor + coords: handled globally by bios-cursor.js ── */

  /* ── Idle view ── */
  function showIdleView() {}
  function hideIdleView() { clearTimeout(idleViewTimer); }

  /* ── Audio: sound-effect hooks (disabled — user will supply real assets) ── */
  function getAudio()        { return null; }
  function playTick()        {}
  /* No-op per user request — hover sounds on product titles/netnodes
     stripped. Function still exported (bios-netgraph.js imports it as
     `playHoverSound` from this module's C-bag) so the call sites in
     bios-main.js:items.mouseenter + bios-netgraph.js netnode hover
     don't error. When sound is wanted back, restore the body:
       BiosAudio.highlightPiezo();
  */
  function playHoverSound()  { /* hover sound disabled */ }
  function playMoshSting()   {}

  /* ── Clocks ── */
  var CLOCK_CITIES = [
    { name: 'Toronto',  tz: 'America/Toronto'  },
    { name: 'New York', tz: 'America/New_York' },
    { name: 'London',   tz: 'Europe/London'    },
    { name: 'Paris',    tz: 'Europe/Paris'     },
    { name: 'Tokyo',    tz: 'Asia/Tokyo'       }
  ];
  /* keep cityTime accessible for mobile ticker */
  function cityTime(tz) {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
    }).format(new Date());
  }

  /* ── Footer clock drum ── */
  var clockDrumEl   = document.getElementById('bios-clock-drum');
  var clockDrumList = document.getElementById('bios-clock-drum-list');
  var clockActiveIdx = 0;
  var clockScrollAcc = 0;
  var CLOCK_ITEM_H   = 40; /* px — must match CSS */

  if (clockDrumList) {
    /* build one item per city */
    CLOCK_CITIES.forEach(function(city) {
      var item   = document.createElement('div');
      item.className = 'bios-clock-drum-item';
      var cityEl = document.createElement('span');
      cityEl.className = 'bios-clock-drum-city';
      cityEl.textContent = city.name.toUpperCase();
      var timeEl = document.createElement('span');
      timeEl.className = 'bios-clock-drum-time';
      timeEl.textContent = '--:--:--';
      item.appendChild(cityEl);
      item.appendChild(timeEl);
      clockDrumList.appendChild(item);
    });
  }

  function setClockDrum(idx, silent) {
    clockActiveIdx = ((idx % CLOCK_CITIES.length) + CLOCK_CITIES.length) % CLOCK_CITIES.length;
    var offset = -clockActiveIdx * CLOCK_ITEM_H;
    if (silent) {
      clockDrumList.style.transition = 'none';
      clockDrumList.style.transform  = 'translateY(' + offset + 'px)';
      clockDrumList.offsetHeight; /* force reflow */
      clockDrumList.style.transition = '';
    } else {
      if (clockDrumList) clockDrumList.style.transform = 'translateY(' + offset + 'px)';
    }
  }

  function tickClocks() {
    if (!clockDrumList) return;
    var items = clockDrumList.querySelectorAll('.bios-clock-drum-item');
    items.forEach(function(item, i) {
      var timeEl = item.querySelector('.bios-clock-drum-time');
      if (timeEl) timeEl.textContent = cityTime(CLOCK_CITIES[i].tz);
    });
  }

  /* scroll to navigate — same feel as product drum */
  if (clockDrumEl) {
    clockDrumEl.addEventListener('wheel', function(e) {
      e.preventDefault();
      clockScrollAcc += e.deltaY;
      if (Math.abs(clockScrollAcc) > 32) {
        setClockDrum(clockActiveIdx + (clockScrollAcc > 0 ? 1 : -1), false);
        clockScrollAcc = 0;
      }
    }, { passive: false });
  }

  setInterval(tickClocks, 1000); tickClocks(); setClockDrum(0, true);

  /* ── Typewriter (load-in) ── */
  function typeIn(el, text, delay, charDelay) {
    if (!el) return;
    var i = 0; el.textContent = '';
    el.classList.add('is-typing');
    setTimeout(function loop() {
      if (i < text.length) {
        el.textContent += text[i++];
        setTimeout(loop, charDelay);
      } else {
        el.classList.remove('is-typing');
      }
    }, delay);
  }

  /* ── Sporadic typing (hover) ── */
  function sporadicDelay() {
    var r = Math.random();
    if (r < 0.08) return Math.floor(Math.random() * 220 + 130);
    if (r < 0.24) return Math.floor(Math.random() * 65  + 40);
    if (r < 0.52) return Math.floor(Math.random() * 28  + 14);
    return Math.floor(Math.random() * 11 + 4);
  }

  /* ── Wave opacity animation ── */
  function startWave(nameEl, item, overrideText) {
    cancelWave(item);
    var text = overrideText !== undefined ? overrideText : (item.dataset.name || '');
    nameEl.innerHTML = '';
    var spans = [];
    for (var ci = 0; ci < text.length; ci++) {
      var sp = document.createElement('span');
      sp.textContent = text[ci];
      nameEl.appendChild(sp);
      spans.push(sp);
    }
    var n = spans.length;
    if (!n) return;
    var beamWidth = Math.max(n * 0.22, 1.2);
    (function loop(ts) {
      var t     = ts * 0.001;
      var range = (n - 1) + beamWidth * 2;
      var peak  = ((t / 2.0) % 1.0) * range - beamWidth;
      for (var i = 0; i < n; i++) {
        var d = i - peak;
        spans[i].style.opacity = 0.18 + 0.82 * Math.exp(-(d * d) / (2 * beamWidth));
      }
      item._waveId = requestAnimationFrame(loop);
    })(performance.now());
  }

  function cancelWave(item) {
    if (item._waveId) { cancelAnimationFrame(item._waveId); item._waveId = null; }
  }

  function startSporadicType(item) {
    /* mobile: only the exact centre item may animate */
    if (isTouchDevice && items[activeIdx] !== item) return;
    var idx    = item.dataset.idx;
    var nameEl = item.querySelector('.bios-item-name');
    var full   = item.dataset.name || '';
    clearTimeout(hoverTimers[idx]);
    cancelWave(item);
    nameEl.textContent = '';
    nameEl.classList.add('is-typing');
    var i = 0;
    (function loop() {
      if (i < full.length) {
        /* typingTick removed per user request — visual typewriter
           stays, audio is suppressed. The universal click/hover SFX
           already provides the audio language; per-character ticks
           on hover added too much noise on top. */
        // BiosAudio.typingTick();
        nameEl.textContent += full[i++];
        hoverTimers[idx] = setTimeout(loop, sporadicDelay());
      } else {
        nameEl.classList.remove('is-typing');
        scrollRevealName(nameEl, item, function() {
          if (item.dataset.soldOut === 'true') {
            var _decay = getSoldOutDecay(item);
            hoverTimers[idx] = setTimeout(function() {
              nameEl.classList.add('is-error');
              if (_decay >= 3) {
                nameEl.classList.add('is-deep-corrupt');
                startWave(nameEl, item, '[ERROR]');
              } else if (_decay === 2) {
                var _KATA = '\u30A2\u30A4\u30A6\u30A8\u30AA\u30A8\u30E9\u30FC'.split('');
                var _et   = '[ERROR]'.split('').map(function(c) {
                  return Math.random() < 0.55 ? _KATA[Math.floor(Math.random()*_KATA.length)] : c;
                }).join('');
                startWave(nameEl, item, _et);
                setTimeout(function() { startErrorGlitch(nameEl, item); }, 800);
              } else if (_decay === 1) {
                var _KATA2 = '\u30A2\u30A4\u30A6\u30A8\u30AA\u30E9\u30FC'.split('');
                var _et2   = '[ERROR]'.split('').map(function(c) {
                  return Math.random() < 0.25 ? _KATA2[Math.floor(Math.random()*_KATA2.length)] : c;
                }).join('');
                startWave(nameEl, item, _et2);
                setTimeout(function() { startErrorGlitch(nameEl, item); }, 800);
              } else {
                startWave(nameEl, item, '[ERROR]');
                setTimeout(function() { startErrorGlitch(nameEl, item); }, 800);
              }
            }, 220);
          } else {
            startWave(nameEl, item);
          }
        });
      }
    })();
  }

  /* ── Scroll-reveal: after typing, pan long names left then right on mobile ── */
  function scrollRevealName(nameEl, item, callback) {
    if (!isTouchDevice) { callback(); return; }
    var fullText = nameEl.textContent;
    nameEl.textContent = '';
    nameEl.classList.remove('is-typing');
    nameEl.classList.add('is-scroll-revealing');
    var inner = document.createElement('span');
    inner.className = 'bios-name-inner';
    inner.textContent = fullText;
    nameEl.appendChild(inner);

    requestAnimationFrame(function() {
      var overflow = inner.scrollWidth - nameEl.clientWidth;
      if (overflow <= 6) {
        /* no meaningful overflow — restore and proceed immediately */
        nameEl.textContent = fullText;
        nameEl.classList.remove('is-scroll-revealing');
        callback();
        return;
      }
      var scrollDur = Math.min(2600, 600 + overflow * 13); /* scale with text length */
      var pauseMs   = 680;                                  /* hold at end before returning */
      var returnDur = Math.round(scrollDur * 0.6);

      inner.style.transition = 'transform ' + scrollDur + 'ms linear';
      inner.style.transform  = 'translateX(-' + overflow + 'px)';

      /* typing tick — delayed ~60ms to align with when CSS transition actually starts */
      setTimeout(function() {
        if (!item._scrollRevealT1 && !item._scrollRevealT2) return; /* already cancelled */
        item._scrollTickInterval = setInterval(function() {
          BiosAudio.typingTick();
        }, 52);
        setTimeout(function() {
          if (item._scrollTickInterval) {
            clearInterval(item._scrollTickInterval);
            item._scrollTickInterval = null;
          }
        }, scrollDur - 60); /* stop ticking when forward scroll ends */
      }, 60);

      item._scrollRevealT1 = setTimeout(function() {
        item._scrollRevealT1 = null;
        inner.style.transition = 'transform ' + returnDur + 'ms ease-in-out';
        inner.style.transform  = 'translateX(0)';
        item._scrollRevealT2 = setTimeout(function() {
          item._scrollRevealT2 = null;
          nameEl.textContent = fullText;
          nameEl.classList.remove('is-scroll-revealing');
          callback();
        }, returnDur + 60);
      }, scrollDur + pauseMs);
    });
  }

  function cancelSporadicType(item) {
    stopErrorGlitch(item);
    var idx = item.dataset.idx;
    clearTimeout(hoverTimers[idx]);
    if (item._scrollRevealT1) { clearTimeout(item._scrollRevealT1); item._scrollRevealT1 = null; }
    if (item._scrollRevealT2) { clearTimeout(item._scrollRevealT2); item._scrollRevealT2 = null; }
    if (item._scrollTickInterval) { clearInterval(item._scrollTickInterval); item._scrollTickInterval = null; }
    cancelWave(item);
    var nameEl = item.querySelector('.bios-item-name');
    if (nameEl) {
      nameEl.classList.remove('is-typing');
      nameEl.classList.remove('is-error');
      nameEl.classList.remove('is-scroll-revealing');
      nameEl.textContent = item.dataset.name || '';
    }
  }

  function getSoldOutDecay(item) {
    if (item.dataset.soldOut !== 'true') return 0;
    var key   = 'bios_decay_' + (item.dataset.handle || item.dataset.displayIdx || '0');
    var count = parseInt(localStorage.getItem(key) || '0', 10);
    localStorage.setItem(key, String(count + 1));
    if (count >= 6) return 3;
    if (count >= 4) return 2;
    if (count >= 2) return 1;
    return 0;
  }

  function startErrorGlitch(nameEl, item) {
    var KATA = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンエラー'.split('');
    function glitchTick() {
      if (!nameEl.classList.contains('is-error')) return;
      var spans = nameEl.querySelectorAll('span');
      if (!spans.length) return;
      var count = Math.random() < 0.4 ? 2 : 1;
      var corrupted = [];
      for (var i = 0; i < count; i++) {
        var idx = Math.floor(Math.random() * spans.length);
        var orig = spans[idx].textContent;
        if (orig === ' ' || orig === '[' || orig === ']') continue;
        spans[idx].textContent = KATA[Math.floor(Math.random() * KATA.length)];
        corrupted.push({ el: spans[idx], orig: orig });
      }
      var restoreDelay = 60 + Math.floor(Math.random() * 60);
      setTimeout(function() {
        corrupted.forEach(function(c) { c.el.textContent = c.orig; });
      }, restoreDelay);
      var nextDelay = 80 + Math.floor(Math.random() * 120);
      item._errorGlitchTimer = setTimeout(glitchTick, nextDelay);
    }
    item._errorGlitchTimer = setTimeout(glitchTick, 100);
  }

  function stopErrorGlitch(item) {
    clearTimeout(item._errorGlitchTimer);
    item._errorGlitchTimer = null;
  }

  /* ── Background glitch ── */
  var GLITCH_CHARS = '\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F2\u30F3\u2591\u2592\u2588\u25A0@#%&*?!01';

  function glitchFrame(original, intensity) {
    var out = '';
    for (var i = 0; i < original.length; i++) {
      out += Math.random() < intensity
        ? GLITCH_CHARS[Math.floor(Math.random() * GLITCH_CHARS.length)]
        : original[i];
    }
    return out;
  }

  function glitchItem(item) {
    if (!item.classList.contains('is-loaded')) return;
    if (item === hoverItem) return;
    if (item.dataset.dist === '0') return;
    var nameEl = item.querySelector('.bios-item-name');
    if (!nameEl || nameEl.classList.contains('is-typing')) return;
    var isSoldOut = item.dataset.soldOut === 'true';
    var original  = item.dataset.name || '';
    var totalFrames = Math.floor(Math.random() * 3) + 2;
    var frame       = 0;
    nameEl.classList.add('is-glitching');
    (function nextFrame() {
      if (frame >= totalFrames) {
        nameEl.textContent = original;
        nameEl.classList.remove('is-error');
        nameEl.classList.remove('is-glitching');
        return;
      }
      nameEl.textContent = glitchFrame(original, Math.max(0.15, 0.85 - frame * 0.22));
      frame++;
      setTimeout(nextFrame, Math.floor(Math.random() * 70 + 45));
    })();
  }

  function scheduleGlitch() {
    var candidates = items.filter(function(item) {
      return item !== hoverItem
        && item.classList.contains('is-loaded')
        && !item.classList.contains('is-filtered-out')
        && item.dataset.dist !== '0';
    });
    if (candidates.length) glitchItem(candidates[Math.floor(Math.random() * candidates.length)]);
    if (Math.random() < 0.3 && candidates.length > 1) {
      var second = candidates.filter(function(c) { return c !== candidates[0]; });
      if (second.length) glitchItem(second[Math.floor(Math.random() * second.length)]);
    }
    setTimeout(scheduleGlitch, Math.floor(Math.random() * 900 + 300));
  }

  /* ── Konami glitch storm ── */
  function triggerGlitchStorm() {
    var END = Date.now() + 3000;
    (function storm() {
      if (Date.now() >= END) {
        items.forEach(function(item) {
          if (!item.classList.contains('is-loaded')) return;
          var nameEl = item.querySelector('.bios-item-name');
          if (nameEl && !nameEl.classList.contains('is-typing')) {
            nameEl.textContent = item.dataset.name || '';
            nameEl.classList.remove('is-error');
            nameEl.classList.remove('is-glitching');
          }
        });
        return;
      }
      var loaded = items.filter(function(it) { return it.classList.contains('is-loaded'); });
      var picks  = Math.floor(Math.random() * 4) + 3;
      for (var k = 0; k < picks && loaded.length; k++) {
        var pick   = loaded[Math.floor(Math.random() * loaded.length)];
        var nameEl = pick.querySelector('.bios-item-name');
        if (nameEl && !nameEl.classList.contains('is-typing')) {
          nameEl.textContent = glitchFrame(pick.dataset.name || '', 0.55 + Math.random() * 0.3);
          nameEl.classList.add('is-glitching');
        }
      }
      setTimeout(storm, 55 + Math.floor(Math.random() * 40));
    })();
  }

  /* ── Konami code detection ── */
  var KONAMI    = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
  var konamiIdx = 0;
  document.addEventListener('keydown', function(e) {
    if (e.key === KONAMI[konamiIdx]) {
      konamiIdx++;
      if (konamiIdx === KONAMI.length) { konamiIdx = 0; triggerGlitchStorm(); }
    } else {
      konamiIdx = (e.key === KONAMI[0]) ? 1 : 0;
    }
  });

  /* ── Drum ── */
  function itemH() {
    return origItems.length ? (origItems[0].getBoundingClientRect().height || 48) : 48;
  }

  function illuminateAt(focalIdx) {
    items.forEach(function(item, i) {
      item.dataset.dist = Math.min(Math.abs(i - focalIdx), 4);
    });
  }

  /* ── Mobile direct-scroll helpers ── */
  var _dragOffset = 0;  /* current list translateY during finger drag */

  function _mobileGetDrumH() {
    var r = drum.getBoundingClientRect();
    return (r.height > 0 ? r.height : drum.offsetHeight) || (window.innerHeight - 175);
  }
  /* Offset needed to centre item idx in the drum */
  function _mobileOffsetForIdx(idx) {
    var el = origItems[idx];
    if (!el) return 0;
    var dH = _mobileGetDrumH();
    return Math.round(dH / 2 - el.offsetTop - el.offsetHeight / 2);
  }
  /* Which page-visible item is closest to drum centre given a list offset */
  function _mobileIdxFromOffset(offset) {
    var _ps = currentPage * PAGE_SIZE;
    var _pe = Math.min(_ps + PAGE_SIZE, origItems.length) - 1;
    var dH  = _mobileGetDrumH();
    var centre = dH / 2;
    var best = _ps, bestDist = Infinity;
    for (var i = _ps; i <= _pe; i++) {
      var el = origItems[i];
      if (!el) continue;
      var itemCY = el.offsetTop + el.offsetHeight / 2 + offset;
      var d = Math.abs(itemCY - centre);
      if (d < bestDist) { bestDist = d; best = i; }
    }
    return best;
  }

  function setDrum(idx, silent) {
    if (!silent && idx !== activeIdx) BiosAudio.scrollTick();
    /* clamp into [0, items.length-1] — no infinite wrap */
    if (idx < 0) idx = 0;
    if (idx > items.length - 1) idx = items.length - 1;
    activeIdx = idx;
    /* In orbit modes the centred #bios-list owns its own transform
       (translateX(-50%) for horizontal centring). Writing translateY
       here would replace that and shoot the list to the left edge.
       The orbit list also shows ALL batch items at once via overflow-y
       auto — there's no "scroll to active item" concept in this view.
       Just illuminate and bail before touching transform. */
    if (drum.classList.contains('is-catalog-orbit-mode') ||
        drum.classList.contains('is-designer-mode')) {
      illuminateAt(activeIdx);
      updateActiveAnimation();
      return;
    }
    var offset;
    if (isTouchDevice) {
      offset = _mobileOffsetForIdx(idx);
      _dragOffset = offset;  /* keep drag baseline in sync */
    } else {
      offset = 56 - activeIdx * itemH();
    }
    if (silent) {
      list.style.transition = 'none';
      list.style.transform  = 'translateY(' + offset + 'px)';
      list.offsetHeight;
      list.style.transition = '';
    } else {
      list.style.transform = 'translateY(' + offset + 'px)';
    }
    illuminateAt(activeIdx);
    updateActiveAnimation();
  }

  /* ── Mobile image peek ── */
  var _peekTimer      = null;
  var _hasScrolled    = false; /* peek only fires after first real scroll gesture */
  var _mobilePeekEl   = document.getElementById('bios-mobile-peek');
  var _peekLoadToken  = 0;   /* increment to cancel any in-flight image load */
  var _peekCurrentSrc = '';  /* src that is currently displayed */

  /* Preload the first image of nearby items so they're cache-ready when scrolled to */
  function preloadNearbyImages(centerIdx) {
    if (!isTouchDevice) return;
    var _ps = currentPage * PAGE_SIZE;
    var _pe = Math.min(_ps + PAGE_SIZE, origItems.length) - 1;
    [-1, 1, 2].forEach(function(off) {
      var idx = centerIdx + off;
      if (idx < _ps || idx > _pe) return;
      var el = origItems[idx];
      if (!el) return;
      var raw = el.dataset.images || '';
      var imgs = raw ? raw.split('|').filter(Boolean) : [];
      var src = imgs[0] || el.dataset.img;
      if (src) { var _pi = new Image(); _pi.src = src; }
    });
  }

  function showMobilePeek(item) {
    if (!_mobilePeekEl || !item) return;
    var raw = item.dataset.images || '';
    var imgs = raw ? raw.split('|').filter(Boolean) : [];
    var src = imgs[0] || item.dataset.img;
    if (!src) return;
    /* already showing the correct image — just ensure visible */
    if (src === _peekCurrentSrc && _mobilePeekEl.classList.contains('is-visible')) return;
    /* claim a token — any in-flight load with an older token is stale */
    var token = ++_peekLoadToken;
    /* preload then swap — image only becomes visible once actually loaded */
    var img = new Image();
    function _commitPeek() {
      if (token !== _peekLoadToken) return; /* cancelled — user moved on */
      _peekCurrentSrc = src;
      _mobilePeekEl.style.backgroundImage = 'url("' + src + '")';
      /* reset animation so it retriggers even if already is-flaring */
      _mobilePeekEl.classList.remove('is-flaring');
      void _mobilePeekEl.offsetWidth; /* force reflow */
      _mobilePeekEl.classList.add('is-visible', 'is-flaring');
    }
    img.onload  = _commitPeek;
    img.onerror = _commitPeek;
    img.src = src;
  }

  function hideMobilePeek() {
    ++_peekLoadToken;  /* cancel any in-flight preload */
    clearTimeout(_peekTimer);
    _peekCurrentSrc = '';
    if (!_mobilePeekEl) return;
    _mobilePeekEl.classList.remove('is-visible', 'is-flaring');
  }

  /* Mobile peek glitch scheduler — parity for desktop image-glitch on hover */
  if (isTouchDevice && _mobilePeekEl) {
    (function schedMobilePeekGlitch() {
      if (_mobilePeekEl.classList.contains('is-visible')) {
        _mobilePeekEl.classList.remove('is-glitching');
        void _mobilePeekEl.offsetWidth;
        _mobilePeekEl.classList.add('is-glitching');
        setTimeout(function () {
          if (_mobilePeekEl) _mobilePeekEl.classList.remove('is-glitching');
        }, 340);
      }
      setTimeout(schedMobilePeekGlitch, 2500 + Math.random() * 5000);
    })();
  }

  /* Trigger typing/[ERROR] animation when scroll lands on an OOS item */
  function updateActiveAnimation() {
    var newActive = items[activeIdx] || null;
    /* always cancel the outgoing item immediately */
    if (prevActiveItem && prevActiveItem !== newActive) {
      if (prevActiveItem !== hoverItem) cancelSporadicType(prevActiveItem);
      if (isTouchDevice) { hideMobilePeek(); cancelDescType(); }
    }
    if (newActive === prevActiveItem) return;
    prevActiveItem = newActive;
    clearTimeout(activeAnimTimer);
    if (!newActive) return;
    /* desktop: animations are mouse-only — scroll never starts type-in or preview */
    if (!isTouchDevice) return;
    /* mobile: short debounce — show image once scroll settles.
       No is-loaded guard: image data is in the dataset from the start.
       showMobilePeek internally uses a token to cancel stale loads. */
    activeAnimTimer = setTimeout(function() {
      if (items[activeIdx] !== newActive) return;   /* moved on already */
      if (newActive === hoverItem) return;           /* hover already owns it */
      showMobilePeek(origItems[activeIdx] || newActive);
      preloadNearbyImages(activeIdx);
    }, 60);
  }

  function updateListProgress() {
    var pct = Math.round(activeIdx / Math.max(1, items.length - 1) * 100);
    /* update inline drum header progress */
    var el = document.getElementById('bios-list-progress');
    if (el) el.textContent = pct + '%';
    /* also push to the footer CPU% slot — drives the manifest CPU readout
       off real scroll progress so it pulses naturally as the user moves
       through the catalog (looks like fluctuating CPU load). Label is
       "CPU" not "SCROLL" so it reads as system telemetry. */
    var cpuEl = document.getElementById('mfs-rev');
    if (cpuEl) cpuEl.textContent = 'CPU ' + String(pct).padStart(3) + '%';
  }

  function navigate(delta, wrap) {
    playTick(wrap);
    var target;
    if (isTouchDevice) {
      /* clamp within the visible page — avoids navigating to hidden items */
      var _ps = currentPage * PAGE_SIZE;
      var _pe = Math.min(_ps + PAGE_SIZE, items.length) - 1;
      target = Math.max(_ps, Math.min(_pe, activeIdx + delta));
    } else {
      target = activeIdx + delta;
      if (target < 0) target = 0;
      if (target > items.length - 1) target = items.length - 1;
    }
    setDrum(target, false);
    updateListProgress();
    /* ripple through the network from the scroll-landing node */
    if (window._netScrollWave) {
      var _waveIdx = activeIdx;
      window._netScrollWave(_waveIdx);
      /* smooth=true: right netgraph animates in sync with drum's 0.14s transition */
      if (window._netScrollToIdx) window._netScrollToIdx(_waveIdx, true);
    }
  }

  /* ── Paginated rendering ─────────────────────────────────────────────────
     renderPage() shows exactly PAGE_SIZE items for `page`, hides the rest,
     resets activeIdx to the first item of the page, and fires a custom event
     so bios-netgraph.js can show the matching nodes.                        ── */
  function renderPage(page) {
    /* In orbit modes (catalog-orbit or designer) the centre list shows a
       FIXED constellation — paginating re-shuffles which items are display:''
       which re-maps origIdx → netnode positions, exploding the ring.
       Bail here so every caller (filter buttons, /CLEAR, /NEW, /ALL, KATIE,
       Escape, page dots, sort, touch overshoot, initial restore) is
       protected by one chokepoint. The initial render at boot is still
       allowed because orbit mode is only added later (on bios:portal-done). */
    if (drum.classList.contains('is-catalog-orbit-mode') ||
        drum.classList.contains('is-designer-mode')) return;
    /* Paginate over VISIBLE items (those not filtered out by [HIDE SOLD]).
       This way HIDE SOLD also gets 5-per-page behavior instead of dumping all
       matches at once. */
    var visible = items.filter(function (i) { return !i.classList.contains('is-filtered-out'); });
    var totalPagesNow = Math.max(1, Math.ceil(visible.length / PAGE_SIZE));
    page = Math.max(0, Math.min(totalPagesNow - 1, page));
    currentPage = page;
    var start = page * PAGE_SIZE;
    var end   = Math.min(start + PAGE_SIZE, visible.length);
    /* Hide every non-filtered item first; filtered-out items are already
       hidden by their .is-filtered-out CSS rule (display: none !important). */
    items.forEach(function (item) {
      if (!item.classList.contains('is-filtered-out')) item.style.display = 'none';
    });
    /* Show the slice of visible items in this page. */
    var firstVisible = null;
    for (var _ri = start; _ri < end; _ri++) {
      visible[_ri].style.display = '';
      if (_ri === start) firstVisible = visible[_ri];
    }
    /* reset active item to first of this page (firstIdx is into the full
       items[] array so the rest of the renderPage logic stays valid). */
    var firstIdx = firstVisible ? items.indexOf(firstVisible) : 0;
    /* Show/hide page dots beyond the current page count. */
    var allDots = drum.querySelectorAll('.bios-page-dot');
    allDots.forEach(function (d, di) {
      d.style.display = di < totalPagesNow ? '' : 'none';
    });
    list.style.transition = 'none';
    list.style.transform  = 'none';
    list.offsetHeight; /* force reflow — items now at natural offsetTop positions */
    list.style.transition = '';
    activeIdx = firstIdx;
    /* On mobile, immediately centre the first item of the page so the
       centre-lock indicator aligns with item 0 from the moment it appears. */
    if (isTouchDevice) {
      var _rp_offset = _mobileOffsetForIdx(firstIdx);
      _dragOffset = _rp_offset;
      list.style.transition = 'none';
      list.style.transform  = 'translateY(' + _rp_offset + 'px)';
      list.offsetHeight;
      list.style.transition = '';
    }
    illuminateAt(firstIdx);
    updateListProgress();
    /* update page dots */
    var dots = drum.querySelectorAll('.bios-page-dot');
    dots.forEach(function (d, di) { d.classList.toggle('is-active', di === page); });
    /* notify netgraph */
    window.dispatchEvent(new CustomEvent('bios:page-change', { detail: { page: page, pageSize: PAGE_SIZE } }));
    /* mobile: clear the previous page's peek image immediately, then show the
       new first item's image once the glitch animation has finished (~320ms left) */
    if (isTouchDevice) {
      hideMobilePeek();
      clearTimeout(activeAnimTimer);
      clearTimeout(_peekTimer);
      prevActiveItem = null; /* force re-trigger on next updateActiveAnimation */
      var _newFirstEl = origItems[firstIdx];
      /* start preloading the new page's images immediately */
      preloadNearbyImages(firstIdx);
      _peekTimer = setTimeout(function() {
        if (activeIdx === firstIdx && _newFirstEl) showMobilePeek(_newFirstEl);
      }, 340);
    }
  }

  function triggerPageTransition(dir) {
    if (isTransitioning) return;
    /* Bail in catalog-orbit / designer mode — paginating the underlying
       product list re-runs item layout + netnode origIdx mapping, which
       explodes the orbit ring. The orbit's "12 newest" batch is a fixed
       constellation; there's no "next page" of orbit. */
    if (drum.classList.contains('is-catalog-orbit-mode') ||
        drum.classList.contains('is-designer-mode')) return;
    /* Dynamic page count based on currently-visible items (respects filter). */
    var _vis = items.filter(function (i) { return !i.classList.contains('is-filtered-out'); });
    var _totalNow = Math.max(1, Math.ceil(_vis.length / PAGE_SIZE));
    var nextPage = currentPage + dir;
    if (nextPage < 0 || nextPage >= _totalNow) return;
    isTransitioning = true;
    _pageWheelAcc = 0;
    /* glitch both panels */
    drum.classList.add('is-page-glitch');
    var netfieldEl = document.getElementById('bios-netfield');
    if (netfieldEl) netfieldEl.classList.add('is-page-glitch');
    /* full-screen flash overlay */
    var flashEl = document.getElementById('bios-page-flash');
    if (flashEl) {
      flashEl.classList.remove('is-active');
      flashEl.offsetHeight; /* force reflow so re-adding is-active re-triggers */
      flashEl.classList.add('is-active');
    }
    BiosAudio.pageStaticBurst();
    BiosAudio.pageFlipSound();
    /* swap content at darkest frame (~38% through 420ms ≈ 160ms) */
    setTimeout(function () {
      renderPage(nextPage);
    }, 160);
    /* remove glitch class after animation */
    setTimeout(function () {
      drum.classList.remove('is-page-glitch');
      if (netfieldEl) netfieldEl.classList.remove('is-page-glitch');
      if (flashEl) flashEl.classList.remove('is-active');
      isTransitioning = false;
    }, 480);
  }

  /* listen for right-side page-next events dispatched by bios-netgraph.js */
  window.addEventListener('bios:page-next', function (e) {
    triggerPageTransition(e.detail.dir);
  });

  /* Right→Left sync: netgraph calls this to move the drum to a specific index */
  window._biosDrumNavToIdx = function (idx) {
    if (typeof idx !== 'number' || isNaN(idx)) return;
    idx = Math.max(0, Math.min(items.length - 1, idx));
    if (idx === activeIdx) return;
    setDrum(idx, true /* silent */);
    updateListProgress();
    if (window._netScrollWave) window._netScrollWave(idx);
  };

  /* ── ASCII art imaging pipeline ────────────────────────────────────────
     Samples the product image at char-cell resolution, maps luminance to a
     terminal char set (' ' light → '█' dark), then reveals line-by-line:
     each line prints as random glitch chars that settle to their true value.
     After the reveal an idle loop briefly re-glitches random rows.        ── */
  var revealCanvas = document.getElementById('bios-reveal-canvas');
  var revealCtx    = revealCanvas ? revealCanvas.getContext('2d') : null;
  var revealTimers = [];
  var currentSrc   = '';

  function clearRevealTimers() {
    for (var ti = 0; ti < revealTimers.length; ti++) clearTimeout(revealTimers[ti]);
    revealTimers = [];
  }

  var _asciiRafId   = null;
  var _asciiIdleTmr = null;

  /* ── Film-strip state ── */
  var _filmInterval = null;
  var _filmIdx      = 0;
  var _filmImages   = [];
  var _filmImgEl    = document.getElementById('bios-preview-img');
  var _filmRefEl    = document.getElementById('bios-preview-ref');
  var _filmStatEl   = document.getElementById('bios-preview-status');
  var _filmCntEl    = document.getElementById('bios-preview-counter');
  var _currentItem  = null;

  /* preload an image URL, fire callback(naturalW, naturalH) when ready */
  function _preloadAndSet(src, cb) {
    var img = new Image();
    img.onload  = function() { cb(img.naturalWidth, img.naturalHeight); };
    img.onerror = function() { cb(0, 0); };
    img.src = src;
  }

  /* resize the preview container to match the image's true aspect ratio */
  function _adjustPreviewSize(natW, natH) {
    if (!preview || !natW || !natH) return;
    var ratio = natW / natH;
    var maxW  = Math.min(window.innerWidth  * 0.42, 580);
    var maxH  = Math.min(window.innerHeight * 0.78, 620);
    var w, h;
    if (maxW / ratio <= maxH) { w = maxW; h = maxW / ratio; }
    else                       { h = maxH; w = maxH * ratio;  }
    preview.style.width  = Math.round(w) + 'px';
    preview.style.height = Math.round(h) + 'px';
  }

  function _setFilmFrame(idx) {
    var src = _filmImages[idx];
    if (!src || !_filmImgEl) return;
    /* fade out first */
    _filmImgEl.style.transition = 'opacity 0.15s ease';
    _filmImgEl.style.opacity = '0';
    var captured = src;
    /* wait for image to actually load, then swap and fade back in */
    _preloadAndSet(src, function() {
      if (_filmImages[idx] !== captured) return; /* item changed mid-flight */
      _filmImgEl.style.backgroundImage = 'url("' + captured + '")';
      requestAnimationFrame(function() {
        _filmImgEl.style.transition = ''; /* restore CSS-class transition */
        _filmImgEl.style.opacity    = ''; /* let .is-visible rule take over */
      });
    });
    if (_filmCntEl && _filmImages.length > 1) {
      _filmCntEl.textContent = '[' + String(idx + 1).padStart(2, '0') + '/' +
                                String(_filmImages.length).padStart(2, '0') + ']';
    }
  }

  /* ── Image preview ── */
  function showPreview(item) {
    if (item === _currentItem) return;
    _currentItem = item;
    clearRevealTimers();
    clearTimeout(hideTimer);
    clearInterval(_filmInterval);

    /* parse pipe-separated image list written by Liquid */
    var raw = item.dataset.images || '';
    _filmImages = raw ? raw.split('|').filter(Boolean) : [];
    if (!_filmImages.length && item.dataset.img) _filmImages = [item.dataset.img];
    if (!_filmImages.length) return;

    _filmIdx   = 0;
    currentSrc = _filmImages[0];

    /* HUD metadata */
    if (_filmRefEl) {
      _filmRefEl.textContent = 'REF: INN-' + String(item.dataset.displayIdx || '?').padStart(3, '0');
    }
    if (_filmStatEl) {
      var isErr = item.dataset.soldOut === 'true';
      _filmStatEl.textContent = 'STATUS: ' + (isErr ? '[ERROR]' : 'AVAILABLE');
      _filmStatEl.style.color = isErr ? '#8a7060' : '';
    }
    if (_filmCntEl) {
      _filmCntEl.textContent = _filmImages.length > 1
        ? '[01/' + String(_filmImages.length).padStart(2, '0') + ']'
        : '';
    }

    /* Show the frame/corners instantly — image fades in once preloaded */
    preview.classList.add('is-visible');
    var _snapshotItem = item;
    _preloadAndSet(_filmImages[0], function(natW, natH) {
      if (_currentItem !== _snapshotItem) return; /* user moved away during load */
      _adjustPreviewSize(natW, natH);
      if (_filmImgEl) {
        _filmImgEl.style.backgroundImage = 'url("' + _filmImages[0] + '")';
        _filmImgEl.style.opacity = ''; /* CSS .is-visible drives fade-in */
      }
    });

    /* auto-advance through frames every 2.8s */
    if (_filmImages.length > 1) {
      _filmInterval = setInterval(function() {
        _filmIdx = (_filmIdx + 1) % _filmImages.length;
        _setFilmFrame(_filmIdx);
      }, 2800);
    }
  }

  function hidePreview() {
    clearRevealTimers();
    clearTimeout(hideTimer);
    clearInterval(_filmInterval);
    _currentItem = null;
    currentSrc   = '';
    hideTimer = setTimeout(function() {
      preview.classList.remove('is-visible');
      if (_filmImgEl) {
        _filmImgEl.style.opacity = '0';
        setTimeout(function() { _filmImgEl.style.backgroundImage = ''; }, 160);
      }
    }, 200);
  }

  /* ── Terminal cart commands ── */
  var cmdMsgTimer = null;
  function showCmdMsg(msg, large) {
    typedEl.textContent = msg;
    if (large) {
      typedEl.classList.add('is-result-msg');
    } else {
      typedEl.classList.remove('is-result-msg');
    }
    /* hide ghost placeholder so it doesn't bleed through the message */
    if (cmdGhostEl) cmdGhostEl.classList.add('is-hidden');
    clearTimeout(cmdMsgTimer);
    cmdMsgTimer = setTimeout(function() {
      typedEl.textContent = '';
      typedEl.classList.remove('is-result-msg');
      /* only restore ghost if search input is also empty */
      if (cmdGhostEl && !searchEl.value) cmdGhostEl.classList.remove('is-hidden');
    }, 2500);
  }

  function addToCart(displayIdx) {
    var target = null;
    for (var k = 0; k < items.length; k++) {
      if (items[k].dataset.displayIdx === String(displayIdx)) { target = items[k]; break; }
    }
    if (!target || !target.dataset.vid) {
      showCmdMsg('ERR: ITEM ' + String(displayIdx).padStart(2,'0') + ' NOT FOUND');
      return;
    }
    showCmdMsg('ADDING ITEM ' + String(displayIdx).padStart(2,'0') + '...', true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(target.dataset.vid, 10), quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      BiosAudio.cartBeep();
      showCmdMsg('CART: ' + (data.title || 'ITEM').toUpperCase().slice(0, 22) + '  +1', true);
    })
    .catch(function() { showCmdMsg('ERR: CART ADD FAILED', true); });
  }

  function fetchCart() {
    showCmdMsg('FETCHING CART...');
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var count = data.item_count || 0;
      var total = '$' + ((data.total_price || 0) / 100).toFixed(2);
      showCmdMsg('CART: ' + count + ' ITEM' + (count !== 1 ? 'S' : '') + '  ' + total);
    })
    .catch(function() { showCmdMsg('ERR: CART FETCH FAILED'); });
  }

  /* ── Last viewed timer ── */
  function updateLastViewed() {
    items.forEach(function(item) {
      var handle = item.dataset.handle;
      if (!handle) return;
      var el  = item.querySelector('.bios-item-accessed');
      if (!el) return;
      var raw = sessionStorage.getItem('last_' + handle);
      if (!raw) { el.textContent = ''; return; }
      var secs = Math.floor((Date.now() - parseInt(raw, 10)) / 1000);
      if (secs < 5)  { el.textContent = 'VIEWED JUST NOW'; return; }
      if (secs < 60) { el.textContent = 'VIEWED ' + secs + 'S AGO'; return; }
      el.textContent = 'VIEWED ' + Math.floor(secs / 60) + 'M AGO';
    });
  }
  setInterval(updateLastViewed, 1000);


  /* ════════════════════════════════════════════════════════════════════════
     MOBILE TICKER — live stock-ticker: world clock + session telemetry
     ════════════════════════════════════════════════════════════════════════ */
  if (isTouchDevice) {
    (function initMobileTicker() {
      var tickerTrackEl = document.getElementById('bios-mobile-ticker-track');
      if (!tickerTrackEl) return;

      function buildTickerContent() {
        var sep = '  ·  ';
        function _t(id, fb) { var e = document.getElementById(id); return e ? e.textContent : fb; }
        return [
          _t('mfs-build',  'BUILD ————'),
          _t('mfs-rev',    'CPU 0%'),
          _t('mfs-uplink', 'UPLINK —— ms'),
          _t('mfs-node',   'NODE ———————'),
          _t('mfs-mem',    'MEM ——/——'),
        ].join(sep);
      }

      /* Static display — update text every second, no scroll animation */
      tickerTrackEl.textContent = buildTickerContent();
      setInterval(function() {
        tickerTrackEl.textContent = buildTickerContent();
      }, 1000);
    })();

    /* ── Mobile: move ELAPSED + action buttons into footer; hide manifest strip ── */
    (function rearrangeFooter() {
      var _footerEl   = document.querySelector('.bios-footer');
      var _manifestEl = document.getElementById('bios-manifest');
      if (!_footerEl) return;
      var _elapsedEl  = document.getElementById('mfs-elapsed');
      var _offerBtn   = document.getElementById('bios-offer-open-btn');
      var _sellBtn    = document.getElementById('bios-sell-open-btn');
      var _chatBtn    = document.getElementById('bios-chat-open-btn');
      var _wrap = document.createElement('div');
      _wrap.className = 'bios-footer-actions';
      [_elapsedEl, _offerBtn, _sellBtn, _chatBtn].forEach(function(el) {
        if (el) _wrap.appendChild(el);
      });
      _footerEl.appendChild(_wrap);
      /* hide manifest strip — content now lives in ticker + footer */
      if (_manifestEl) _manifestEl.style.display = 'none';
    })();
  }

  /* ── Search + sort/filter ── */
  var _activeSort = '';   /* 'soldout' | 'low' | 'high' | '' */

  /* applyFilter only controls the [HIDE SOLD] toggle now — search terms are
     shown only in the results popup (showSearchResults below), never as a
     live filter on the catalog list. The `q` argument is accepted for
     backwards compat with old call sites but is ignored.

     renderPage paginates over visible items, so HIDE SOLD also paginates
     5-per-page (instead of dumping every match at once). */
  function applyFilter(/* q */) {
    var hasSoldoutFilter = _activeSort === 'soldout';
    origItems.forEach(function (item) {
      var matches = !hasSoldoutFilter || item.dataset.soldOut !== 'true';
      item.classList.toggle('is-filtered-out', !matches);
    });
    /* Always re-render from page 0 of the (possibly filtered) set. */
    _edgeOvershoot = 0;
    renderPage(0);
  }

  /* ── Search results popup ─────────────────────────────────────────────────
     Shown when the user hits Enter with a non-empty query — gives a focused,
     scrollable chooser instead of just opening the first match. */
  var resultsPopup = document.getElementById('bios-results-popup');
  var resultsList  = document.getElementById('bios-results-list');
  var resultsMeta  = document.getElementById('bios-results-meta');
  var resultsClose = document.getElementById('bios-results-close');

  function _escHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function closeSearchResults() {
    if (!resultsPopup) return;
    resultsPopup.classList.remove('is-open');
    resultsPopup.setAttribute('aria-hidden', 'true');
  }
  function _firstImageOf(item) {
    var raw = item.dataset.images || '';
    var imgs = raw ? raw.split('|').filter(Boolean) : [];
    return imgs[0] || item.dataset.img || '';
  }

  function showSearchResults(query) {
    if (!resultsPopup || !resultsList) return;
    var q = (query || '').trim().toLowerCase();
    /* Match by name or vendor against origItems. Honor the [SOLD OUT] toggle
       so popup results align with whatever the catalog is currently showing. */
    var hideSold = _activeSort === 'soldout';
    var matches = origItems.filter(function(it) {
      if (hideSold && it.dataset.soldOut === 'true') return false;
      if (!q) return true; /* empty query (shouldn't normally fire) = all */
      var name   = (it.dataset.name   || '').toLowerCase();
      var vendor = (it.dataset.vendor || '').toLowerCase();
      return name.indexOf(q) !== -1 || vendor.indexOf(q) !== -1;
    });
    resultsList.innerHTML = '';
    if (matches.length === 0) {
      resultsList.innerHTML = '<li class="bios-result-empty">// NO MATCHES FOR "' + _escHtml((query || '').toUpperCase()) + '"</li>';
    } else {
      matches.forEach(function(item, _i) {
        var li = document.createElement('li');
        li.className = 'bios-result-item';
        li.setAttribute('role', 'option');
        /* Stagger index for the CSS keyframe in .bios-results-popup */
        li.style.setProperty('--row-i', _i);
        var name    = item.dataset.name || 'UNTITLED';
        var price   = item.dataset.price || '';
        var soldOut = item.dataset.soldOut === 'true';
        var img     = _firstImageOf(item);
        var thumbHTML = img
          ? '<span class="bios-result-thumb" style="background-image:url(\'' + _escHtml(img).replace(/'/g, "\\'") + '\')"></span>'
          : '<span class="bios-result-thumb bios-result-thumb-empty"></span>';
        li.innerHTML =
          thumbHTML +
          '<span class="bios-result-name">' + _escHtml(name) + '</span>' +
          '<span class="bios-result-price">' + (soldOut ? '[ SOLD ]' : _escHtml(price)) + '</span>';
        li.addEventListener('click', function() {
          closeSearchResults();
          openOverlay(item);
        });
        /* Per-row hover ping — reuses the global highlight piezo so the
           result list feels like the same column as catalog items. */
        li.addEventListener('mouseenter', function () {
          try { if (window.BiosAudio) window.BiosAudio.highlightPiezo(); } catch (_) {}
        });
        resultsList.appendChild(li);
      });
    }
    if (resultsMeta) {
      resultsMeta.textContent = matches.length + ' MATCH' + (matches.length === 1 ? '' : 'ES');
    }
    resultsPopup.classList.add('is-open');
    resultsPopup.setAttribute('aria-hidden', 'false');
    try { if (window.BiosAudio) window.BiosAudio.searchOpen(); } catch (_) {}
  }
  if (resultsClose) resultsClose.addEventListener('click', closeSearchResults);
  if (resultsPopup) {
    resultsPopup.addEventListener('click', function(e) {
      /* Backdrop click only — don't close if user clicked inside the panel. */
      if (e.target === resultsPopup) closeSearchResults();
    });
  }
  /* Esc handler already exists below in the keydown listener; piggyback via a flag check there. */

  /* Snapshot the items that will be affected by a filter / sort click,
     then strobe them with .is-filter-flicker so the list visibly "reshuffles"
     instead of snapping. For HIDE SOLD: items toggling visibility. For
     LOW/HIGH: every item already visible (because their order changes).
     Staggered ~30ms per row so the flicker ripples down the list. */
  function _triggerFilterFlicker(targets) {
    targets.forEach(function (item, i) {
      var d = i * 30;
      setTimeout(function () {
        item.classList.add('is-filter-flicker');
        setTimeout(function () { item.classList.remove('is-filter-flicker'); }, 300);
      }, d);
    });
  }

  function _applySort(mode) {
    var prevSort = _activeSort;
    /* toggle off if same mode clicked again */
    _activeSort = (_activeSort === mode) ? '' : mode;
    ['soldout','low','high'].forEach(function(m) {
      var b = document.getElementById('bios-filter-' + m);
      if (b) { b.classList.toggle('is-active', _activeSort === m); b.setAttribute('aria-pressed', String(_activeSort === m)); }
    });

    /* Pick which items to flicker BEFORE we mutate state.
         - HIDE SOLD toggling: the sold-out items (they're the ones changing
           visibility — either disappearing or coming back).
         - LOW/HIGH toggling: every item currently rendered on the page
           (they're all reshuffling positions). */
    var isSoldoutToggle = (mode === 'soldout');
    var flickerTargets;
    if (isSoldoutToggle) {
      flickerTargets = origItems.filter(function (i) { return i.dataset.soldOut === 'true'; });
    } else {
      flickerTargets = origItems.filter(function (i) {
        return !i.classList.contains('is-filtered-out')
          && i.style.display !== 'none';
      });
    }

    if (_activeSort === 'low') {
      origItems.sort(function(a, b) { return parseInt(a.dataset.priceCents || 0) - parseInt(b.dataset.priceCents || 0); });
    } else if (_activeSort === 'high') {
      origItems.sort(function(a, b) { return parseInt(b.dataset.priceCents || 0) - parseInt(a.dataset.priceCents || 0); });
    } else {
      /* restore original arrival order via data-display-idx */
      origItems.sort(function(a, b) { return parseInt(a.dataset.displayIdx || 0) - parseInt(b.dataset.displayIdx || 0); });
    }
    origItems.forEach(function(item, i) { item.dataset.idx = i; list.appendChild(item); });
    currentPage = 0; activeIdx = 0;
    /* applyFilter handles render itself: it bypasses pagination when a filter
       is active, or calls renderPage(currentPage) when not. Calling renderPage
       again here would overwrite that decision. */
    applyFilter();

    /* Fire the wave after the DOM has re-rendered so .is-filtered-out items
       that just came back into view are display:block and animatable. */
    requestAnimationFrame(function () {
      _triggerFilterFlicker(flickerTargets);
    });
  }

  ['soldout','low','high'].forEach(function(m) {
    var btn = document.getElementById('bios-filter-' + m);
    if (btn) btn.addEventListener('click', function() {
      _applySort(m);
      try { if (window.BiosAudio) window.BiosAudio.highlightPiezo(); } catch (_) {}
    });
  });

  function onTyping() {
    caretEl.classList.add('is-active');
    clearTimeout(typingTimer);
    typingTimer = setTimeout(function() { caretEl.classList.remove('is-active'); }, 600);
  }

  var cmdGhostEl  = document.getElementById('bios-cmd-ghost');
  var cmdOutputEl = document.getElementById('bios-cmd-output');
  var _cmdOutTimer = null;

  /* ── Command audio — swap asset filenames when MP3s are uploaded.
     URLs come from window.__INNOCENCES_ASSETS__ (set inline by
     sections/main-content.liquid) since Liquid can't run in this file. */
  var _cmdAudioUrls = {
    help: (window.__INNOCENCES_ASSETS__ || {}).cmdHelpMp3 || '',
    info: (window.__INNOCENCES_ASSETS__ || {}).cmdInfoMp3 || ''
  };
  var _cmdAudioPlaying = null;

  function _playCommandAudio(key) {
    var url = _cmdAudioUrls[key] || '';
    /* stop any currently playing command audio */
    if (_cmdAudioPlaying) {
      try { _cmdAudioPlaying.pause(); _cmdAudioPlaying.currentTime = 0; } catch(e) {}
      _cmdAudioPlaying = null;
    }
    if (!url || url.indexOf('cdn') === -1) {
      /* file not yet uploaded — show placeholder message */
      showCmdMsg('/' + key.toUpperCase() + ' — AUDIO FILE NOT YET LOADED');
      return;
    }
    var audio = new Audio(url);
    audio.volume = 0.85;
    _cmdAudioPlaying = audio;
    showCmdMsg('> /' + key.toUpperCase() + ' — PLAYING\u2026');
    audio.play().catch(function() {
      showCmdMsg('AUDIO BLOCKED — TAP SCREEN TO UNLOCK');
    });
    audio.addEventListener('ended', function() { _cmdAudioPlaying = null; });
  }

  function showCmdOutput(lines) {
    if (!cmdOutputEl) return;
    cmdOutputEl.innerHTML = '';
    lines.forEach(function(l) {
      var el = document.createElement('div');
      el.className = 'bios-cmd-output-line' + (l.cls ? ' ' + l.cls : '');
      el.textContent = l.t || '';
      cmdOutputEl.appendChild(el);
    });
    var dim = document.createElement('div');
    dim.className = 'bios-cmd-output-dim';
    dim.textContent = '[ ESC OR ANY KEY TO DISMISS ]';
    cmdOutputEl.appendChild(dim);
    cmdOutputEl.classList.add('is-visible');
    cmdOutputEl.removeAttribute('aria-hidden');
    clearTimeout(_cmdOutTimer);
    _cmdOutTimer = setTimeout(hideCmdOutput, 14000);
  }

  /* ── PS2 emulator easter egg open/close ─────────────────────────
     Iframe injected lazily on first activation so the page weight
     stays clean for normal visitors. Loads a self-hosted EmulatorJS
     wrapper (assets/ps2-emulator.html) running the Play! PS2 core
     against a user-uploaded ROM + BIOS pair (URLs configured inside
     that HTML file). Modal traps focus on the iframe so keyboard
     input goes to the emulator; ESC closes the modal.

     Function name kept as `_openDoom` for code-history continuity —
     the DOM IDs (bios-doom-overlay, bios-doom-stage, bios-doom-close)
     are also preserved so the existing CSS rules don't need editing.
     The visible labels + the iframe src are the only things that
     actually changed from the previous DOOM implementation. */
  function _openDoom() {
    var doomOverlay = document.getElementById('bios-doom-overlay');
    var stage       = document.getElementById('bios-doom-stage');
    if (!doomOverlay || !stage) return;
    /* Inject iframe only if not already present (re-opens reuse it). */
    if (!stage.querySelector('iframe')) {
      /* iframe src is the asset URL of /assets/ps2-emulator.html,
         passed via data-emulator-src on the overlay element so the
         Liquid asset_url filter resolves to the cache-busted CDN URL
         at render time. Fallback if the attribute is missing so the
         function still tries (yields a 404 — visible failure mode). */
      var emulatorSrc = doomOverlay.getAttribute('data-emulator-src') || '/assets/ps2-emulator.html';
      var iframe = document.createElement('iframe');
      iframe.src = emulatorSrc;
      iframe.setAttribute('allow', 'fullscreen; autoplay; gamepad');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('webkitallowfullscreen', '');
      iframe.setAttribute('mozallowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      iframe.title = 'PS2 Emulator — Play! by jpd002';
      stage.appendChild(iframe);
    }
    doomOverlay.classList.add('is-open');
    doomOverlay.setAttribute('aria-hidden', 'false');
    /* Pause the YouTube music player so it doesn't fight DOOM's audio. */
    try { if (window._biosYtPlayer && window._biosYtPlayer.pauseVideo) window._biosYtPlayer.pauseVideo(); } catch (_) {}
    /* Move focus to the iframe so keyboard input is captured by DOOM
       rather than the parent page. setTimeout because iframe needs
       a tick to mount + register listeners. */
    setTimeout(function () {
      var iframe = stage.querySelector('iframe');
      if (iframe) try { iframe.focus(); } catch (_) {}
    }, 60);
  }
  function _closeDoom() {
    var doomOverlay = document.getElementById('bios-doom-overlay');
    if (!doomOverlay) return;
    doomOverlay.classList.remove('is-open');
    doomOverlay.setAttribute('aria-hidden', 'true');
    /* Resume music if the user had it playing. */
    try { if (window._biosYtPlayer && window._biosYtPlayer.playVideo) window._biosYtPlayer.playVideo(); } catch (_) {}
  }
  /* Wire close button + ESC key + backdrop click. */
  (function _wireDoomClose() {
    var doomOverlay = document.getElementById('bios-doom-overlay');
    var closeBtn    = document.getElementById('bios-doom-close');
    if (closeBtn) closeBtn.addEventListener('click', _closeDoom);
    if (doomOverlay) {
      doomOverlay.addEventListener('click', function (e) {
        /* Backdrop click (not iframe stage click) closes the modal. */
        if (e.target === doomOverlay) _closeDoom();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && doomOverlay && doomOverlay.classList.contains('is-open')) {
        /* Only swallow ESC if the overlay is actually open — otherwise
           let DOOM (the iframe) and other modals handle it. */
        _closeDoom();
      }
    });
  })();

  function hideCmdOutput() {
    if (!cmdOutputEl) return;
    cmdOutputEl.classList.remove('is-visible');
    cmdOutputEl.setAttribute('aria-hidden', 'true');
    clearTimeout(_cmdOutTimer);
  }

  searchEl.addEventListener('input', function() {
    typedEl.textContent = searchEl.value;
    onTyping();
    /* DOOM easter-egg trigger moved from `input` to the Enter
       handler below so the modal doesn't auto-fire while the user
       is still typing — opens only on a deliberate Enter press. */
    /* ghost text: hide when typing, show when empty */
    if (cmdGhostEl) cmdGhostEl.classList.toggle('is-hidden', searchEl.value.length > 0);
    /* dismiss command output if user starts typing a new command */
    if (searchEl.value.length > 0) hideCmdOutput();
  });

  searchEl.addEventListener('focus', function() { cmdLine.classList.add('is-focused'); });
  searchEl.addEventListener('blur',  function() { cmdLine.classList.remove('is-focused'); });
  cmdLine.addEventListener('click',  function() { searchEl.focus(); });

  /* ── Keyboard ── */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault(); navigate(1, activeIdx >= items.length - 1); return;
    }
    if (e.key === 'ArrowUp') {
      e.preventDefault(); navigate(-1, activeIdx <= 0); return;
    }
    if (e.key === 'Enter') {
      /* Don't intercept Enter when another input (e.g. chat) has focus */
      var _ae = document.activeElement;
      if (_ae && _ae !== searchEl && (_ae.tagName === 'INPUT' || _ae.tagName === 'TEXTAREA')) return;
      var cmd = searchEl.value.trim().toUpperCase();
      /* ── PS2 emulator easter egg ─────────────────────────────────
         Only opens on a deliberate Enter press. Iframe is injected
         lazily inside _openDoom() so cold-load weight is unaffected.
         Trigger word swapped from DOOM → PS2 when the emulator was
         changed from Internet Archive's shareware DOOM (DOSBox) to
         the Play! PS2 emulator (EmulatorJS). DOM IDs preserved for
         backward compat with the existing CSS rules. */
      if (cmd === 'PS2') {
        _openDoom();
        searchEl.value = ''; typedEl.textContent = '';
        e.preventDefault(); return;
      }
      if (/^ADD\s+\d+$/.test(cmd)) {
        addToCart(parseInt(cmd.replace(/^ADD\s+/, ''), 10));
        searchEl.value = ''; typedEl.textContent = '';
        e.preventDefault(); return;
      }
      if (cmd === 'CART') {
        fetchCart(); searchEl.value = ''; typedEl.textContent = '';
        e.preventDefault(); return;
      }
      if (cmd === 'CLEAR') {
        searchEl.value = ''; typedEl.textContent = ''; applyFilter('');
        e.preventDefault(); return;
      }
      /* ── /store — glitchy redirect to [STORE] ── */
      if (cmd === '/STORE') {
        searchEl.value = ''; typedEl.textContent = '';
        if (cmdGhostEl) cmdGhostEl.classList.remove('is-hidden');
        showCmdMsg('ROUTING TO [STORE]...');
        /* fire full-screen flash + page glitch, then redirect */
        var _sfDrum = drum;
        var _sfNet  = document.getElementById('bios-netfield');
        var _sfFlash= document.getElementById('bios-page-flash');
        _sfDrum.classList.add('is-page-glitch');
        if (_sfNet)   _sfNet.classList.add('is-page-glitch');
        if (_sfFlash) { _sfFlash.classList.remove('is-active'); _sfFlash.offsetHeight; _sfFlash.classList.add('is-active'); }
        BiosAudio.pageStaticBurst();
        setTimeout(function() { window.location.href = '/pages/store'; }, 480);
        e.preventDefault(); return;
      }
      /* ── /new and /all — clear filter, show all ── */
      if (cmd === '/NEW' || cmd === '/ALL') {
        searchEl.value = ''; typedEl.textContent = ''; applyFilter('');
        if (cmdGhostEl) cmdGhostEl.classList.remove('is-hidden');
        showCmdMsg('SHOWING ALL ITEMS');
        e.preventDefault(); return;
      }
      /* ── /[keyword] catch-all — show results popup for keyword ── */
      if (cmd.length > 1 && cmd.charAt(0) === '/') {
        var _fWord = cmd.slice(1).trim().toLowerCase();
        if (_fWord) {
          searchEl.value = _fWord; typedEl.textContent = _fWord;
          if (cmdGhostEl) cmdGhostEl.classList.add('is-hidden');
          showSearchResults(_fWord);
          e.preventDefault(); return;
        }
      }
      /* ── /help command — plays audio recording ── */
      if (cmd === '/HELP') {
        searchEl.value = ''; typedEl.textContent = '';
        if (cmdGhostEl) cmdGhostEl.classList.remove('is-hidden');
        _playCommandAudio('help');
        e.preventDefault(); return;
      }
      /* ── Easter egg: KATIE ── */
      if (cmd === 'KATIE') {
        searchEl.value = ''; typedEl.textContent = ''; applyFilter('');
        e.preventDefault();
        var _root = document.getElementById('bios-root');
        if (_root) {
          _root.style.transition = 'filter 0.6s ease';
          _root.style.filter = 'hue-rotate(290deg) saturate(9) brightness(1.25)';
          setTimeout(function() {
            _root.style.transition = 'filter 2.5s ease';
            _root.style.filter = '';
            setTimeout(function() { _root.style.transition = ''; }, 2600);
          }, 10000);
        }
        return;
      }
      /* Enter on a non-empty query → show search-results popup so the user can
         pick from multiple matches (the catalog list also filters live, but the
         popup is a discrete, focused chooser).
         Enter on an empty query → open the currently active item in the overlay. */
      var q = searchEl.value.trim();
      if (q) {
        showSearchResults(q);
      } else {
        var t = hoverItem || items[activeIdx];
        if (t) openOverlay(t);
      }
      e.preventDefault();
      return;
    }
    if (e.key === 'Escape') {
      /* If the search-results popup is open, close that first and stop. */
      if (resultsPopup && resultsPopup.classList.contains('is-open')) {
        closeSearchResults();
        return;
      }
      if (hoverItem) { hidePreview(); cancelSporadicType(hoverItem); hoverItem = null; }
      searchEl.value = ''; typedEl.textContent = ''; applyFilter('');
      if (cmdGhostEl) cmdGhostEl.classList.remove('is-hidden');
      hideCmdOutput();
      return;
    }
    /* any other key while output is visible = dismiss it */
    if (cmdOutputEl && cmdOutputEl.classList.contains('is-visible') &&
        !e.ctrlKey && !e.metaKey && e.key.length === 1) {
      hideCmdOutput();
    }
    if ((e.key === 'r' || e.key === 'R') && !e.ctrlKey && !e.metaKey && !e.altKey && document.activeElement !== searchEl) {
      var rpItem = items[activeIdx];
      if (rpItem) {
        localStorage.setItem('bios_restore', (rpItem.dataset.handle || '') + ':' + (rpItem.dataset.displayIdx || '0'));
        showCmdMsg('RESTORE POINT SAVED \u2014 INN-' + String(rpItem.dataset.displayIdx || '?').padStart(3,'0'));
      }
      return;
    }
    if (!e.ctrlKey && !e.metaKey && !e.altKey && e.key.length === 1) {
      if (document.activeElement !== searchEl) searchEl.focus();
    }
  });

  searchEl.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
    /* Keystroke SFX — fires once per keypress. Filters out:
       - Pure modifier presses (Shift/Ctrl/Alt/Meta) that don't produce
         a character or affect the input.
       - e.repeat (held key auto-repeats) so holding backspace doesn't
         machine-gun the sound.
       - Tab (focus change, not a search action).
       Branch:
       - Backspace / Delete       → undo.wav (erasing has its own cue)
       - Everything else (letters,
         numbers, Space, Enter,
         arrows, punctuation)    → key.wav
       Volume 0.20 for both — quieter than clicks since keystrokes
       fire fast. Fresh new Audio() per keystroke avoids AbortError
       from rapid currentTime resets. */
    var MOD_KEYS = { Shift: 1, Control: 1, Alt: 1, Meta: 1, CapsLock: 1, Tab: 1 };
    if (MOD_KEYS[e.key]) return;
    if (e.repeat) return;
    var _sfxUrl = (e.key === 'Backspace' || e.key === 'Delete')
      ? 'https://cdn.shopify.com/s/files/1/0762/5726/3866/files/undo.wav?v=1779655474'
      : 'https://cdn.shopify.com/s/files/1/0762/5726/3866/files/key.wav?v=1779655299';
    try {
      var k = new Audio(_sfxUrl);
      k.volume = 0.20;
      var kp = k.play();
      if (kp && typeof kp.catch === 'function') kp.catch(function () {});
    } catch (_) {}
  });

  /* ── Scroll wheel — triggers page transition (not within-page scroll) ──
     BUT: bail in catalog-orbit mode and designer mode so the centered
     list scrolls naturally (overflow-y: auto on #bios-list) instead of
     paginating the underlying product list — paginating during orbit
     re-shuffles netnode origIdx mappings and "explodes" the ring.
     We don't even preventDefault here so the native list scroll runs. */
  drum.addEventListener('wheel', function(e) {
    if (drum.classList.contains('is-catalog-orbit-mode') ||
        drum.classList.contains('is-designer-mode')) {
      return;
    }
    e.preventDefault();
    if (isTransitioning) return;
    _pageWheelAcc += e.deltaY;
    if (Math.abs(_pageWheelAcc) > 50) {
      triggerPageTransition(_pageWheelAcc > 0 ? 1 : -1);
    }
  }, { passive: false });


  /* ── Touch swipe on drum (mobile) — direct position tracking ──
     The list moves 1-to-1 with the finger. Active item = whichever item's
     centre is closest to the drum's centre-lock at any moment.
     On release the list snaps to the nearest item via CSS transition.
     This guarantees the highlighted item always matches what is centred.   ── */
  var touchStartY  = 0;
  var touchLastY   = 0;
  var touchTapItem = null;
  /* Overshoot accumulator — how far past the page edge the user has dragged */
  var _edgeOvershoot = 0;
  var PAGE_OVERSHOOT = 88;   /* px past edge → page flip */

  drum.addEventListener('touchstart', function(e) {
    touchStartY = e.touches[0].clientY;
    touchLastY  = touchStartY;
    _edgeOvershoot = 0;
    cancelDescType();
    clearTimeout(activeAnimTimer);
    /* keep the current peek image visible during touch — touchmove will swap it
       per item as activeIdx crosses item boundaries. (Page transitions still
       call hideMobilePeek via renderPage.) */
    if (prevActiveItem) { cancelSporadicType(prevActiveItem); prevActiveItem = null; }

    /* Capture the list's current translateY so dragging resumes from exactly here */
    var _m = list.style.transform.match(/translateY\((-?[\d.]+)px\)/);
    _dragOffset = _m ? parseFloat(_m[1]) : _mobileOffsetForIdx(activeIdx);

    /* Freeze transition during drag — motion is 1-to-1 with finger */
    list.style.transition = 'none';

    /* Tap detection — record which item was under the finger */
    touchTapItem = null;
    var el = e.target;
    while (el && el !== drum) {
      if (el.classList && el.classList.contains('bios-item')) { touchTapItem = el; break; }
      el = el.parentElement;
    }
  }, { passive: true });

  drum.addEventListener('touchmove', function(e) {
    e.preventDefault();
    var y  = e.touches[0].clientY;
    var dy = touchLastY - y;   /* +ve = finger moved up = scroll toward next item */
    touchLastY = y;
    if (Math.abs(dy) < 0.5) return;   /* ignore sub-pixel jitter */

    touchTapItem = null;   /* finger moved — not a tap */
    _hasScrolled = true;
    BiosAudio.seekNoise(dy);   /* continuous HDD-seek noise, scales with velocity */

    var _ps  = currentPage * PAGE_SIZE;
    var _pe  = Math.min(_ps + PAGE_SIZE, origItems.length) - 1;
    var minOff = _mobileOffsetForIdx(_pe);   /* last item at centre — most negative */
    var maxOff = _mobileOffsetForIdx(_ps);   /* first item at centre — most positive */

    _dragOffset -= dy;

    /* ── Page-transition via deliberate overshoot past the edge ── */
    if (_dragOffset < minOff) {
      _edgeOvershoot += (_dragOffset - minOff);   /* negative accumulation */
      if (_edgeOvershoot < -PAGE_OVERSHOOT && !isTransitioning) {
        triggerPageTransition(1);
        _edgeOvershoot = 0;
        _dragOffset    = minOff;
        return;
      }
    } else if (_dragOffset > maxOff) {
      _edgeOvershoot += (_dragOffset - maxOff);   /* positive accumulation */
      if (_edgeOvershoot > PAGE_OVERSHOOT && !isTransitioning) {
        triggerPageTransition(-1);
        _edgeOvershoot = 0;
        _dragOffset    = maxOff;
        return;
      }
    } else {
      _edgeOvershoot = 0;
    }

    /* ── Rubber-band past page edges (30 % resistance) ── */
    var display = _dragOffset;
    if (_dragOffset < minOff) display = minOff + (_dragOffset - minOff) * 0.30;
    if (_dragOffset > maxOff) display = maxOff + (_dragOffset - maxOff) * 0.30;

    list.style.transform = 'translateY(' + display + 'px)';

    /* ── Real-time active index = item whose centre is at the centre-lock ── */
    var newIdx = _mobileIdxFromOffset(display);
    if (newIdx !== activeIdx) {
      BiosAudio.scrollTick();  /* per-item floppy sector click */
      activeIdx = newIdx;
      illuminateAt(activeIdx);
      updateListProgress();
      /* Show the peek image continuously as the user scrolls, not only after
         they stop. showMobilePeek dedupes by src and uses a token to cancel
         stale loads, so rapid calls during a fast scroll are safe. */
      if (origItems[activeIdx]) showMobilePeek(origItems[activeIdx]);
      if (window._netScrollWave) window._netScrollWave(activeIdx);
      if (window._netScrollToIdx) window._netScrollToIdx(activeIdx, true);
    }
  }, { passive: false });

  drum.addEventListener('touchend', function(e) {
    var totalDrift = Math.abs(touchStartY - e.changedTouches[0].clientY);

    /* Tap: finger barely moved, valid item → open overlay */
    if (totalDrift < 18 && touchTapItem) {
      list.style.transition = '';   /* restore before navigation */
      if (touchTapItem.dataset.priceCents === '999') {
        if (window._biosOpenMarket) window._biosOpenMarket(touchTapItem.dataset.handle || '');
      } else {
        openOverlay(touchTapItem);
      }
      touchTapItem = null;
      return;
    }

    /* Snap: re-enable CSS transition and lock to the nearest item */
    list.style.transition = '';
    var _ps  = currentPage * PAGE_SIZE;
    var _pe  = Math.min(_ps + PAGE_SIZE, origItems.length) - 1;
    var snap = Math.max(_ps, Math.min(_pe, activeIdx));
    setDrum(snap, false);           /* centres item, plays sound, shows image */
    updateListProgress();
    if (window._netScrollWave) window._netScrollWave(activeIdx);
    if (window._netScrollToIdx) window._netScrollToIdx(activeIdx, true);

    touchTapItem   = null;
    _edgeOvershoot = 0;
  }, { passive: true });

  /* ── Init ── */
  /* (no clone set to pre-load any more — originals all type-in below) */

  var previewTimer    = null;
  var _descHoverTimer = null;   /* fires after 2.5 s to start typing description */
  var _descTypingTmr  = null;   /* per-char typing timeout handle                */

  /* ── Type product description directly into the terminal command line ── */
  function startDescType(item) {
    var desc = (item.dataset.description || '').trim();
    if (!desc) return;
    /* clear any existing input and hide the ghost hint */
    searchEl.value = '';
    typedEl.textContent = '';
    if (cmdGhostEl) cmdGhostEl.classList.add('is-hidden');

    var ci = 0;
    function typeTick() {
      if (ci < desc.length) {
        BiosAudio.typingTick();
        typedEl.textContent = desc.slice(0, ++ci);
        _descTypingTmr = setTimeout(typeTick, 22 + Math.random() * 18);
      }
      /* when done, leave text in place until mouseleave clears it */
    }
    typeTick();
  }

  function cancelDescType() {
    clearTimeout(_descHoverTimer);
    clearTimeout(_descTypingTmr);
    _descHoverTimer = null;
    _descTypingTmr  = null;
    typedEl.textContent = '';
    if (cmdGhostEl) cmdGhostEl.classList.remove('is-hidden');
  }

  items.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      clearTimeout(idleViewTimer);
      hideIdleView();
      hoverItem = item;
      playHoverSound();
      var hoverIdx = parseInt(item.dataset.idx, 10);
      illuminateAt(hoverIdx);
      clearTimeout(previewTimer);
      showPreview(item);
      /* Activate the corresponding right-side node by original index */
      if (window._setNetActive) window._setNetActive(hoverIdx);
      var handle = item.dataset.handle;
      if (handle) sessionStorage.setItem('last_' + handle, String(Date.now()));
      /* Re-type the title on hover so the name "scans in" each time the
         mouse lands on a row — gives every item its own active moment,
         not just the centered one. cancelSporadicType (mouseleave handler
         below) clears the in-progress type if the mouse moves on quickly,
         so sweeping the list doesn't queue up a stack of retypes. */
      /* Visual typewriter re-enabled — user wanted ONLY the per-char
         typingTick sound removed (handled inside startSporadicType:228
         where the BiosAudio.typingTick call is commented out). The
         visual character-by-character print on hover stays. */
      if (!isTouchDevice) startSporadicType(item);
    });
    item.addEventListener('mouseleave', function() {
      clearTimeout(previewTimer);
      if (hoverItem === item) {
        hoverItem = null;
        illuminateAt(activeIdx);
        hidePreview();
        if (window._clearNetActive) window._clearNetActive();
        clearTimeout(idleViewTimer);
        idleViewTimer = setTimeout(showIdleView, 120000);
      }
      cancelSporadicType(item);
    });
    item.addEventListener('click', function() {
      if (item.dataset.priceCents === '999') {
        if (window._biosOpenMarket) window._biosOpenMarket(item.dataset.handle || '');
        return;
      }
      openOverlay(item);
    });
  });

  var lastItemDelay = 300 + Math.max(0, items.length - 1) * 110;
  items.forEach(function(item, i) {
    var nameEl = item.querySelector('.bios-item-name');
    setTimeout(function() {
      item.classList.add('is-loaded');
      item.dataset.dist = Math.min(Math.abs(i - activeIdx), 4);
      typeIn(nameEl, item.dataset.name || '', 0, 22);
    }, 300 + i * 110);
  });

  setTimeout(scheduleGlitch, lastItemDelay + 1200);

  /* ── Network Graph — full-viewport product node field ─────────────────────
     Logic lives in assets/bios-netgraph.js to stay within template size limit.
     Pass accessor functions for mutable outer-scope vars so the external file
     can read and write hoverItem, idleViewTimer, and activeIdx cleanly.    ── */
  if (window._biosInitNetGraph) {
    window._biosInitNetGraph({
      origItems:          origItems,
      items:              items,
      /* list is no longer cloned 3× — pass MID:0 so legacy `items[MID + i]`
         indexing inside bios-netgraph.js still resolves to the original item. */
      MID:                0,
      isTouchDevice:      isTouchDevice,
      getHoverItem:       function ()  { return hoverItem; },
      setHoverItem:       function (v) { hoverItem = v; },
      getActiveIdx:       function ()  { return activeIdx; },
      getIdleTimer:       function ()  { return idleViewTimer; },
      setIdleTimer:       function (v) { idleViewTimer = v; },
      illuminateAt:       illuminateAt,
      startSporadicType:  startSporadicType,
      cancelSporadicType: cancelSporadicType,
      playHoverSound:     playHoverSound,
      hideIdleView:       hideIdleView,
      showIdleView:       showIdleView,
      hidePreview:        hidePreview,
      showPreview:        showPreview,
      openOverlay:        openOverlay
    });
  }

  /* ── Build page indicator dots ── */
  (function () {
    var indEl = document.createElement('div');
    indEl.className = 'bios-page-indicator';
    for (var _pi = 0; _pi < totalPages; _pi++) {
      var dot = document.createElement('span');
      dot.className = 'bios-page-dot' + (_pi === 0 ? ' is-active' : '');
      dot.setAttribute('data-page', _pi);
      /* tap dot to jump directly to that page (mobile-friendly) */
      (function(_page) {
        dot.addEventListener('click', function() {
          if (isTransitioning || _page === currentPage) return;
          isTransitioning = true;
          drum.classList.add('is-page-glitch');
          var _flashEl = document.getElementById('bios-page-flash');
          if (_flashEl) { _flashEl.classList.remove('is-active'); _flashEl.offsetHeight; _flashEl.classList.add('is-active'); }
          BiosAudio.pageStaticBurst();
          setTimeout(function() { renderPage(_page); }, 160);
          setTimeout(function() {
            drum.classList.remove('is-page-glitch');
            if (_flashEl) _flashEl.classList.remove('is-active');
            isTransitioning = false;
          }, 480);
        });
      })(_pi);
      indEl.appendChild(dot);
    }
    drum.appendChild(indEl);
  })();

  /* ── Initial page render ── */
  requestAnimationFrame(function () {
    renderPage(0);  /* renderPage already calls preloadNearbyImages(firstIdx) */
    /* mobile: fade in the first item's image on load without needing to scroll */
    if (isTouchDevice) {
      setTimeout(function() {
        var _initEl = origItems[activeIdx] || items[activeIdx];
        if (_initEl) showMobilePeek(_initEl);
      }, 300);
    }
  });

  /* show idle view once everything is loaded */
  setTimeout(showIdleView, lastItemDelay + 400);

  /* ── Feature 1: Product detail overlay ── */
  var overlayEl    = document.getElementById('bios-overlay');
  var overlayInner = document.getElementById('bios-overlay-inner');
  var overlayOpen  = false;
  var overlayItem  = null;

  /* Carousel state */
  var _ovImages   = [];
  var _ovIdx      = 0;
  var _ovActiveSlot = 'a'; /* which img slot is currently shown */

  var _ovImgA    = document.getElementById('bios-ov-img-a');
  var _ovImgB    = document.getElementById('bios-ov-img-b');
  var _ovCounter = document.getElementById('bios-ov-counter');
  var _ovDots    = document.getElementById('bios-ov-dots');
  var _ovControls = document.getElementById('bios-ov-controls');
  var _ovTitle   = document.getElementById('bios-ov-title');
  var _ovMeta    = document.getElementById('bios-ov-meta');
  var _ovDesc    = document.getElementById('bios-ov-desc');
  var _ovCartBtn = document.getElementById('bios-ov-cart-btn');
  var _ovCloseBtn = document.getElementById('bios-ov-close');

  function _ovUpdateDots() {
    if (!_ovDots) return;
    _ovDots.innerHTML = '';
    _ovImages.forEach(function(_, i) {
      var d = document.createElement('span');
      d.className = 'bios-ov-dot' + (i === _ovIdx ? ' is-active' : '');
      d.setAttribute('data-i', i);
      _ovDots.appendChild(d);
    });
  }

  function _ovUpdateCounter() {
    if (!_ovCounter) return;
    var tot = String(_ovImages.length).padStart(2, '0');
    var cur = String(_ovIdx + 1).padStart(2, '0');
    _ovCounter.textContent = '[' + cur + '/' + tot + ']';
  }

  function _ovGoTo(idx) {
    if (!_ovImages.length) return;
    idx = ((idx % _ovImages.length) + _ovImages.length) % _ovImages.length;
    if (idx === _ovIdx) return;
    _ovIdx = idx;
    /* cross-fade: load next into idle slot, fade active out then swap */
    var nextSlot = _ovActiveSlot === 'a' ? 'b' : 'a';
    var nextEl   = nextSlot === 'a' ? _ovImgA : _ovImgB;
    var curEl    = _ovActiveSlot === 'a' ? _ovImgA : _ovImgB;
    nextEl.src   = _ovImages[_ovIdx];
    nextEl.style.opacity = '0';
    nextEl.style.zIndex  = '2';
    curEl.style.zIndex   = '1';
    /* small rAF to ensure src loads before fade */
    requestAnimationFrame(function() {
      nextEl.style.opacity = '1';
      setTimeout(function() {
        curEl.style.opacity = '0';
        _ovActiveSlot = nextSlot;
      }, 80);
    });
    _ovUpdateCounter();
    _ovUpdateDots();
  }

  /* Build the .bios-ov-related-list of N nearest-neighbour products
     for the currently-active overlay item. Mirrors the picker logic
     the satellite layer used (±1, ±2, ±3 around origIdx wrapped to
     catalog length) so the same neighbours that orbited the dialog
     now appear as a clean inline list on the right. Each entry has
     thumb / title / price / truncated description; clicking re-opens
     the overlay on that neighbour, swapping the main image. */
  function buildRelatedList(item) {
    var listEl = document.getElementById('bios-ov-related-list');
    if (!listEl || !item) return;
    listEl.innerHTML = '';
    var rawIdx = parseInt(item.dataset.idx, 10);
    if (isNaN(rawIdx)) {
      listEl.innerHTML = '<li class="bios-ov-related-empty">// no related items</li>';
      return;
    }
    var N = origItems.length;
    if (N <= 1) {
      listEl.innerHTML = '<li class="bios-ov-related-empty">// no neighbours</li>';
      return;
    }
    /* origItems may be the tripled array (length MID*3); rawIdx might
       index into the full items[] array. Resolve to a canonical
       origItems-relative index. */
    var origIdx = rawIdx % N;
    if (origIdx < 0) origIdx += N;

    /* Pick up to 5 nearest neighbours (wrap around the catalog). Same
       offsets as the original satellite layer for visual continuity. */
    var offsets = [-1, 1, -2, 2, -3, 3, -4, 4];
    var picked  = [];
    var seen = {}; seen[origIdx] = true;
    for (var oi = 0; oi < offsets.length && picked.length < 5; oi++) {
      var ni = ((origIdx + offsets[oi]) % N + N) % N;
      if (seen[ni]) continue;
      seen[ni] = true;
      picked.push(ni);
    }

    if (!picked.length) {
      listEl.innerHTML = '<li class="bios-ov-related-empty">// no neighbours</li>';
      return;
    }

    picked.forEach(function (ni) {
      var neighbor = origItems[ni];
      if (!neighbor) return;
      var li = document.createElement('li');
      li.className = 'bios-ov-related-item';
      li.setAttribute('role', 'button');
      li.setAttribute('tabindex', '0');
      li.dataset.idx = ni;

      var thumb = document.createElement('div');
      thumb.className = 'bios-ov-related-thumb';
      var imgUrl = neighbor.dataset.img || '';
      if (imgUrl) thumb.style.backgroundImage = 'url("' + imgUrl + '")';

      var body = document.createElement('div');
      body.className = 'bios-ov-related-body';

      var row = document.createElement('div');
      row.className = 'bios-ov-related-row';
      var titleEl = document.createElement('span');
      titleEl.className = 'bios-ov-related-title';
      /* Same vendor-prefix dim treatment as the featured title — keeps
         the related list visually consistent so users can spot the
         product identity past the brand prefix at a glance. */
      var nbName   = neighbor.dataset.name || '— UNTITLED —';
      var nbVendor = neighbor.dataset.vendor || '';
      if (typeof window._biosDimVendorPrefix === 'function' && nbVendor) {
        titleEl.innerHTML = window._biosDimVendorPrefix(nbName, nbVendor);
      } else {
        titleEl.textContent = nbName;
      }
      var priceEl = document.createElement('span');
      priceEl.className = 'bios-ov-related-price';
      priceEl.textContent = neighbor.dataset.price || '—';
      row.appendChild(titleEl);
      row.appendChild(priceEl);

      var descEl = document.createElement('div');
      descEl.className = 'bios-ov-related-desc';
      var rawDesc = (neighbor.dataset.description || '').replace(/\s+/g, ' ').trim();
      descEl.textContent = rawDesc || '— no description on file —';

      body.appendChild(row);
      body.appendChild(descEl);
      li.appendChild(thumb);
      li.appendChild(body);

      var clickHandler = function (e) {
        e.preventDefault();
        e.stopPropagation();
        openOverlay(neighbor);
      };
      li.addEventListener('click', clickHandler);
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') clickHandler(e);
      });

      listEl.appendChild(li);
    });
  }

  function buildOverlay(item) {
    if (!item) return;

    /* ── Images ── */
    var rawImages = item.dataset.images || '';
    _ovImages = rawImages ? rawImages.split('|').filter(function(u) { return u.trim(); }) : [];
    if (!_ovImages.length && item.dataset.img) _ovImages = [item.dataset.img];
    _ovIdx = 0;
    _ovActiveSlot = 'a';

    if (_ovImgA) { _ovImgA.src = _ovImages[0] || ''; _ovImgA.alt = item.dataset.name || ''; _ovImgA.style.opacity = '1'; _ovImgA.style.zIndex = '2'; }
    if (_ovImgB) { _ovImgB.src = ''; _ovImgB.style.opacity = '0'; _ovImgB.style.zIndex = '1'; }

    var single = _ovImages.length <= 1;
    if (_ovControls) _ovControls.style.display = single ? 'none' : '';
    if (_ovDots)     _ovDots.style.display     = single ? 'none' : '';
    _ovUpdateCounter();
    _ovUpdateDots();

    /* ── Title (header bar — minimal "ITEM 03 / NAME" reference) ── */
    var idx2 = String(item.dataset.displayIdx || '??').padStart(2, '0');
    if (_ovTitle) _ovTitle.textContent = 'ITEM ' + idx2 + ' / ' + (item.dataset.name || '');

    /* ── Featured slots (title + price + vendor/status meta) ──
       The redesigned overlay's right column has a featured block with
       large title + amber price + compact meta row. Populate from the
       item's own dataset so values are always accurate to the current
       product, not stale from a prior open. */
    var soldOut    = item.dataset.soldOut === 'true';
    var statusTxt  = soldOut ? '[OUT OF STOCK]' : 'AVAILABLE';
    var statusCls  = soldOut ? 'bios-ov-status-err' : 'bios-ov-status-ok';

    var _ovFeaturedTitle = document.getElementById('bios-ov-featured-title');
    var _ovFeaturedPrice = document.getElementById('bios-ov-featured-price');
    var _ovFeaturedMeta  = document.getElementById('bios-ov-featured-meta');
    if (_ovFeaturedTitle) {
      /* Dim vendor prefix if the title starts with the vendor name —
         e.g. "5351 POUR LES HOMMES BLACK CARGO PANTS" with vendor
         "5351 POUR LES HOMMES" renders the vendor in dim grey so the
         actual product identity stands out. Falls back to plain text
         if the helper isn't yet loaded. */
      if (typeof window._biosDimVendorPrefix === 'function') {
        _ovFeaturedTitle.innerHTML = window._biosDimVendorPrefix(
          item.dataset.name || '',
          item.dataset.vendor || ''
        );
      } else {
        _ovFeaturedTitle.textContent = item.dataset.name || '';
      }
    }
    if (_ovFeaturedPrice) _ovFeaturedPrice.textContent = item.dataset.price || '—';
    if (_ovFeaturedMeta) {
      _ovFeaturedMeta.innerHTML = '';
      var compactRows = [
        { k: 'VENDOR', v: item.dataset.vendor || 'UNKNOWN', cls: '' },
        { k: 'STATUS', v: statusTxt,                         cls: statusCls },
        { k: 'SKU',    v: item.dataset.sku    || '—',       cls: '' }
      ];
      compactRows.forEach(function (row) {
        var cell = document.createElement('span');
        cell.className = 'bios-ov-meta-cell';
        var k = document.createElement('span');
        k.className = 'bios-ov-meta-key';
        k.textContent = row.k + ': ';
        var v = document.createElement('span');
        v.className = 'bios-ov-meta-val' + (row.cls ? ' ' + row.cls : '');
        v.textContent = row.v;
        cell.appendChild(k);
        cell.appendChild(v);
        _ovFeaturedMeta.appendChild(cell);
      });
    }
    /* Legacy hidden meta slot — drained empty so nothing renders out. */
    if (_ovMeta) _ovMeta.innerHTML = '';

    /* Related-products list removed per simplified overlay redesign.
       The buildRelatedList() function + #bios-ov-related-list element
       remain in the codebase as no-ops in case we want to bring the
       list back. Calling it here would still work (the list is
       display:none in CSS) but skipping the rebuild saves a few ms
       of DOM thrash per open. */
    /* buildRelatedList(item); */

    /* ── Description ── */
    if (_ovDesc) {
      var _rawDesc = (item.dataset.description || '').replace(/\s+/g, ' ').trim();
      if (_rawDesc.toUpperCase() === 'ERROR') {
        _ovDesc.classList.add('is-art');
        _ovDesc.textContent = '⠀⠀⠀⠀⠀⠀⠀⢀⣤⣤⡀\n⠀⠀⠀⠀⠀⠀⠀⢸⣿⣿⡇\n⠀⠀⠀⠀⠀⣀⣤⣾⣿⣟\n⠀⠀⠀⠀⣾⣿⡿⠿⠿⠿⣿⣦\n⠀⠀⠀⢸⣿⣿⡇⢠⡄⢀⣿⣿⡄\n⠀⠀⠀⣿⡟⣿⣿⣿⠃⣸⣿⣿⣧\n⠀⠀⢸⣿⠁⣸⣿⡟⠀⣿⣿⡌⢿⣧\n⠀⠀⣾⡇⠀⣿⣿⣃⣸⣿⣿⣿⠈⠻⣷⣄⡀\n⠀⢠⡟⠀⢠⣿⣿⣿⣿⣿⣿⣿⣧⠀⠈⢿⡦\n⠀⠀⠀⠀⣾⣿⣿⣿⠛⠛⣿⣿⣿⣧\n⠀⠀⠀⢸⣿⡿⠋⠁⠀⠀⠀⠈⠻⣿⣿⡄\n⠀⠀⣰⣿⠟⠁⠀⠀⠀⠀⠀⠀⠀⠀⠘⣿⣧\n⠀⣼⣿⡏⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢹⣿⣧\n⣸⡿⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⢿⣇';
      } else {
        _ovDesc.classList.remove('is-art');
        _ovDesc.textContent = _rawDesc || 'NO DATA';
      }
    }

    /* ── Cart button — text-link form ── */
    if (_ovCartBtn) {
      _ovCartBtn.textContent = soldOut ? '[ out of stock ]' : '[ add to cart ]';
      _ovCartBtn.classList.toggle('is-sold-out', soldOut);
      _ovCartBtn.onclick = null;
      if (!soldOut) {
        _ovCartBtn.onclick = function(e) {
          /* The cart trigger is an <a href="#"> now (text-link form),
             so we must preventDefault to stop the page jumping to top. */
          if (e && typeof e.preventDefault === 'function') e.preventDefault();
          var displayIdx = item.dataset.displayIdx;
          _ovCartBtn.textContent = 'adding...';
          _ovCartBtn.classList.add('is-sold-out');   /* disable hover */
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(item.dataset.vid, 10), quantity: 1 })
          })
          .then(function(r) { return r.json(); })
          .then(function(data) {
            BiosAudio.cartBeep();
            _ovCartBtn.textContent = 'added \u2713';
            showCmdMsg('CART: ' + (data.title || 'ITEM').toUpperCase().slice(0, 22) + '  +1', true);
            /* close overlay after brief confirmation pause \u2014 closeOverlay() handles the glitch animation */
            setTimeout(function() { closeOverlay(); }, 650);
          })
          .catch(function() {
            _ovCartBtn.textContent = '[ err — retry ]';
            _ovCartBtn.classList.remove('is-sold-out');
            showCmdMsg('ERR: CART ADD FAILED', true);
          });
        };
      }
    }
  }

  function openOverlay(item) {
    if (!overlayEl || !overlayInner || !item) return;
    overlayItem = item;
    /* Item-click signature cue. Plays sfx-item-click.mp3 when deployed
       (ElevenLabs glass+tape switch) or falls back to the original
       overlayOpen sine sweep if the sample isn't in /assets yet. */
    try { if (window.BiosAudio) window.BiosAudio.itemClick(); } catch (_) {}
    /* Clear any existing satellites (they're hidden in CSS but still
       cleared so the canvas RAF stops). The redesigned overlay uses
       an inline related-list inside .bios-ov-side instead of the
       floating satellite layer. */
    if (window._biosClearSatellites) window._biosClearSatellites();
    buildOverlay(item);
    overlayEl.classList.add('is-open');
    overlayOpen = true;
    /* Scroll the side panel back to top (featured + related list both
       reset to their natural top positions on each open). */
    var sideEl = document.querySelector('.bios-ov-side');
    if (sideEl) sideEl.scrollTop = 0;
    var relatedEl = document.getElementById('bios-ov-related-list');
    if (relatedEl) relatedEl.scrollTop = 0;
    /* Satellite spawn intentionally disabled — the inline related-list
       inside .bios-ov-side replaces it.
       (re-enable by uncommenting if you ever want the floating layer back) */
    /* if (window._biosUpdateSatellites) {
      setTimeout(function () { window._biosUpdateSatellites(item); }, 80);
    } */
  }

  function closeOverlay() {
    if (!overlayEl) return;
    if (overlayEl.classList.contains('is-glitch-close')) return; /* already closing */
    try { if (window.BiosAudio) window.BiosAudio.overlayClose(); } catch (_) {}
    overlayEl.classList.add('is-glitch-close');
    setTimeout(function() {
      overlayEl.classList.remove('is-open');
      overlayEl.classList.remove('is-glitch-close');
      overlayOpen = false;
      overlayItem = null;
      if (window._biosClearSatellites) window._biosClearSatellites();
      /* restore product image that was hidden when overlay opened */
      if (isTouchDevice) showMobilePeek(origItems[activeIdx] || null);
    }, 440);
  }

  /* Carousel arrow buttons */
  (function() {
    var prevBtn = document.getElementById('bios-ov-prev');
    var nextBtn = document.getElementById('bios-ov-next');
    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); _ovGoTo(_ovIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); _ovGoTo(_ovIdx + 1); });
    /* dot click */
    if (_ovDots) _ovDots.addEventListener('click', function(e) {
      var t = e.target;
      if (t.classList.contains('bios-ov-dot')) { e.stopPropagation(); _ovGoTo(parseInt(t.dataset.i, 10)); }
    });
    /* close button */
    if (_ovCloseBtn) _ovCloseBtn.addEventListener('click', function(e) { e.stopPropagation(); closeOverlay(); });
  })();

  /* click overlay backdrop → close */
  if (overlayEl) {
    overlayEl.addEventListener('click', function(e) {
      if (e.target === overlayEl) { closeOverlay(); }
    });
  }

  /* ── Overlay carousel: swipe left/right to navigate images (mobile) ── */
  (function() {
    var _ovCarouselEl = document.getElementById('bios-ov-carousel');
    if (!_ovCarouselEl) return;
    var _cSwX = 0;
    _ovCarouselEl.addEventListener('touchstart', function(e) {
      _cSwX = e.touches[0].clientX;
    }, { passive: true });
    _ovCarouselEl.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - _cSwX;
      if (Math.abs(dx) > 36) _ovGoTo(_ovIdx + (dx < 0 ? 1 : -1));
    }, { passive: true });
  })();

  /* Mobile: swipe-down on overlay header to close */
  if (isTouchDevice && overlayInner) {
    var _ovSwipeStartY = 0;
    var _ovSwipeLive   = false;
    var ovHeader = overlayInner.querySelector('.bios-ov-header');
    if (ovHeader) {
      ovHeader.addEventListener('touchstart', function(e) {
        _ovSwipeStartY = e.touches[0].clientY;
        _ovSwipeLive   = true;
      }, { passive: true });
      ovHeader.addEventListener('touchend', function(e) {
        if (!_ovSwipeLive) return;
        _ovSwipeLive = false;
        var dy = e.changedTouches[0].clientY - _ovSwipeStartY;
        if (dy > 55) closeOverlay(); /* swipe down ≥55px → close */
      }, { passive: true });
    }
  }

  /* Signal element removed — uplink animation disabled */

  /* ── Feature 3: Ambient particle drift ── */
  function createParticleSystem(partCanvas) {
    if (!partCanvas) return;
    var partCtx = partCanvas.getContext('2d');
    if (!partCtx) return;
    var particles = [];
    function initParticles() {
      partCanvas.width  = window.innerWidth;
      partCanvas.height = window.innerHeight;
      var w = partCanvas.width, h = partCanvas.height;
      particles = [];
      /* Mobile: fewer particles at lower opacity to preserve battery */
      var p0 = isTouchDevice ? 35 : 262;
      var p1 = isTouchDevice ?  6 :  34;
      for (var pi = 0; pi < p0; pi++) {
        particles.push({
          x: Math.random()*w, y: Math.random()*h,
          vx:(Math.random()-0.5)*0.058, vy:-0.010-Math.random()*0.045,
          wx:(Math.random()-0.5)*0.0015,
          r: Math.random()*1.4+0.1,
          a: Math.random()*(isTouchDevice ? 0.16 : 0.30)+(isTouchDevice ? 0.02 : 0.05),
          aDir:Math.random()<0.5?1:-1, aMag:0.0006+Math.random()*0.001,
          aMin:0.04, aMax:isTouchDevice ? 0.22 : 0.45, type:0
        });
      }
      for (var mi = 0; mi < p1; mi++) {
        particles.push({
          x: Math.random()*w, y: Math.random()*h,
          vx:(Math.random()-0.5)*0.022, vy:-0.003-Math.random()*0.015,
          wx:(Math.random()-0.5)*0.0007,
          r: 1.8+Math.random()*2.0,
          a: Math.random()*(isTouchDevice ? 0.09 : 0.18)+(isTouchDevice ? 0.02 : 0.04),
          aDir:Math.random()<0.5?1:-1, aMag:0.0003+Math.random()*0.0006,
          aMin:0.02, aMax:isTouchDevice ? 0.14 : 0.28, type:1
        });
      }
    }
    (function animatePart() {
      var w = partCanvas.width, h = partCanvas.height;
      partCtx.clearRect(0, 0, w, h);
      particles.forEach(function(p) {
        p.vx += p.wx; p.x += p.vx; p.y += p.vy;
        if (p.x < -4) p.x = w+4; if (p.x > w+4) p.x = -4;
        if (p.y < -4) p.y = h+4; if (p.y > h+4) p.y = -4;
        p.a += p.aDir*p.aMag;
        if (p.a >= p.aMax) { p.a = p.aMax; p.aDir = -1; }
        if (p.a <= p.aMin) { p.a = p.aMin; p.aDir =  1; }
        partCtx.beginPath();
        partCtx.arc(p.x, p.y, p.r, 0, Math.PI*2);
        partCtx.fillStyle = p.type===1 ? 'rgba(160,148,128,'+p.a+')' : 'rgba(195,182,158,'+p.a+')';
        partCtx.fill();
      });
      requestAnimationFrame(animatePart);
    })();
    initParticles();
    window.addEventListener('resize', function() {
      partCanvas.width  = window.innerWidth;
      partCanvas.height = window.innerHeight;
      initParticles();
    }, { passive: true });
  }
  /* Particles: full count desktop, reduced count mobile (CSS sets opacity 0.28 on mobile) */
  createParticleSystem(document.getElementById('bios-particles'));

  /* ── Feature 5: Hex rain canvas ── */
  function initHexRain(rc) {
    if (!rc) return;
    var rx = rc.getContext('2d');
    var RW, RH, rcols, rdrops, rspeeds, ropac;
    var RHEX = '0123456789ABCDEF';
    /* Mobile: wider columns (fewer) and lower opacity to save battery */
    var RCOL = isTouchDevice ? 72 : 40;
    var _hexOpBase = isTouchDevice ? 0.004 : 0.007;
    var _hexOpRange = isTouchDevice ? 0.007 : 0.014;
    function rreset() {
      RW = rc.width  = window.innerWidth;
      RH = rc.height = window.innerHeight;
      rcols = Math.floor(RW / RCOL);
      rdrops = []; rspeeds = []; ropac = [];
      for (var ci = 0; ci < rcols; ci++) {
        rdrops.push(-(Math.random() * (RH / 14)));
        rspeeds.push(0.25 + Math.random() * 0.45);
        ropac.push(_hexOpBase + Math.random() * _hexOpRange);
      }
    }
    rreset();
    window.addEventListener('resize', rreset, { passive: true });
    (function rdraw() {
      rx.clearRect(0, 0, RW, RH);
      rx.font = '12px Mononoki,ui-monospace,"Courier New",monospace';
      for (var ci = 0; ci < rcols; ci++) {
        var trail = 10 + Math.floor(Math.random() * 6);
        for (var ti = 0; ti < trail; ti++) {
          var py = (rdrops[ci] - ti) * 14;
          if (py < 0 || py > RH) continue;
          var al = ropac[ci] * (1 - ti / trail);
          rx.fillStyle = 'rgba(90,82,70,' + al.toFixed(3) + ')';
          rx.fillText(RHEX[Math.floor(Math.random() * 16)], ci * RCOL, py);
        }
        rdrops[ci] += rspeeds[ci];
        if (rdrops[ci] * 14 > RH + 14 * 16) rdrops[ci] = -(Math.random() * 20);
      }
      requestAnimationFrame(rdraw);
    })();
  }
  /* Hex rain: runs on all devices — mobile uses wider columns + lower opacity */
  initHexRain(document.getElementById('bios-hexrain'));

  /* ── Horizontal glitch bars ── */
  (function() {
    var gc = document.getElementById('bios-glitch-bars');
    if (!gc) return;
    var gx = gc.getContext('2d');
    var GW, GH;
    function gresize() { GW = gc.width = window.innerWidth; GH = gc.height = window.innerHeight; }
    gresize();
    window.addEventListener('resize', gresize, { passive: true });

    function flashBars() {
      var numBars = 1 + Math.floor(Math.random() * 3);
      var frames = 0, maxFrames = 4 + Math.floor(Math.random() * 6);
      var bars = [];
      for (var b = 0; b < numBars; b++) {
        bars.push({
          y:  Math.floor(Math.random() * GH),
          h:  1 + Math.floor(Math.random() * 4),
          al: 0.03 + Math.random() * 0.07
        });
      }
      function frame() {
        gx.clearRect(0, 0, GW, GH);
        if (frames >= maxFrames) {
          scheduleNext();
          return;
        }
        bars.forEach(function(bar) {
          /* subtle brightness shift — amber tint */
          gx.fillStyle = 'rgba(200,188,155,' + (bar.al * (1 - frames / maxFrames)).toFixed(3) + ')';
          gx.fillRect(0, bar.y, GW, bar.h);
        });
        frames++;
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function scheduleNext() {
      setTimeout(flashBars, 6000 + Math.random() * 14000);
    }
    scheduleNext();
  })();

  /* ── Ghost in the Shell: full-width canvas code rain ── */
  function initCodeRain(canvas, waitForBoot) {
      if (!canvas) return;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;

      /* ── Helpers ── */
      function rI(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
      function rF(a, b) { return Math.random() * (b - a) + a; }
      function rH(n) { var s = ''; for (var i = 0; i < n; i++) s += '0123456789ABCDEF'[rI(0, 15)]; return s; }
      function rIp() { return rI(10,192)+'.'+rI(0,255)+'.'+rI(0,255)+'.'+rI(1,254); }
      function rPort() { return [80,443,8080,3000,22,53,6379,5432,27017,6443,2375,9200][rI(0,11)]; }
      function rPid() { return rI(1000, 65535); }
      function rMs() { return rI(1, 999); }
      function rTs() { return '['+rI(0,999999).toString().padStart(6,'0')+'.'+rI(0,999999).toString().padStart(6,'0')+']'; }
      function pick(arr) { return arr[rI(0, arr.length - 1)]; }

      /* ── Session content library — 17 session types ── */
      var SESSION_TYPES = [

        /* 0: bash ls + stat */
        function() {
          var dir = pick(['/var/log','/etc/nginx','/opt/app','/srv/data','/home/op']);
          var mon = pick(['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']);
          return [
            '$ ls -lah ' + dir,
            'total ' + rI(40,800) + 'K',
            'drwxr-xr-x  ' + rI(2,12) + ' root root ' + rI(1,9) + 'K ' + mon + ' ' + rI(1,28) + ' ' + rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ' .',
            '-rw-r--r--  1 root root ' + rI(1,999) + 'K ' + pick(['access.log','error.log','syslog','auth.log','app.log','kern.log']),
            '-rw-r--r--  1 root root ' + rI(1,99) + 'K ' + pick(['config.yml','nginx.conf','app.conf','settings.json']),
            '-rwxr-xr-x  1 root root ' + rI(1,9) + 'M ' + pick(['server','worker','daemon','agent','proxy']),
            '$ stat ' + dir + '/' + pick(['access.log','error.log','app.log']),
            '  File: ' + dir + '/access.log',
            '  Size: ' + rI(10000,9999999) + '  Blocks: ' + rI(8,9999) + ' IO Block: 4096',
            '  Inode: ' + rI(100000,9999999) + '  Links: 1',
          ];
        },

        /* 1: ps aux process monitor */
        function() {
          return [
            '$ ps aux --sort=-%cpu | head -12',
            'USER       PID %CPU %MEM    VSZ   RSS STAT COMMAND',
            'root      ' + rPid() + '  ' + rI(0,99) + '.' + rI(0,9) + ' ' + rF(0,8).toFixed(1) + '  ' + rI(100000,999999) + ' ' + rI(10000,99999) + ' R    node /opt/app/server.js',
            'postgres  ' + rPid() + '  ' + rI(0,40) + '.' + rI(0,9) + ' ' + rF(0,4).toFixed(1) + '  ' + rI(100000,500000) + ' ' + rI(5000,50000) + ' S    postgres: autovacuum',
            'www-data  ' + rPid() + '   ' + rI(0,9) + '.' + rI(0,9) + ' ' + rF(0,2).toFixed(1) + '  ' + rI(50000,200000) + ' ' + rI(2000,20000) + ' S    nginx: worker process',
            'root      ' + rPid() + '   0.' + rI(0,9) + ' 0.' + rI(0,2) + '   ' + rI(10000,99999) + '  ' + rI(500,5000) + ' Ss   /usr/sbin/sshd',
            'redis     ' + rPid() + '   0.' + rI(0,9) + ' 0.' + rI(0,2) + '   ' + rI(10000,50000) + '  ' + rI(2000,9000) + ' Ssl  redis-server *:6379',
            'op        ' + rPid() + '   0.0 0.0   ' + rI(1000,9000) + '   ' + rI(100,999) + ' R+   ps aux --sort=-%cpu',
          ];
        },

        /* 2: npm install / build */
        function() {
          var pkg = pick(['react','webpack','typescript','vite','esbuild','rollup','next']);
          return [
            '$ npm install ' + pkg + '@' + rI(1,20) + '.' + rI(0,15) + '.' + rI(0,9),
            'npm warn deprecated ' + pick(['inflight','glob','rimraf']) + ': this version is no longer supported',
            'npm warn deprecated graceful-fs@3.0.5: please upgrade to graceful-fs 4',
            'added ' + rI(1,400) + ' packages, audited ' + rI(100,2000) + ' packages in ' + rI(1,60) + 's',
            rI(0,3) + ' vulnerabilities (' + rI(0,2) + ' low, ' + rI(0,2) + ' moderate)',
            'Run `npm audit` for details',
            '$ npm run build',
            '> vite build',
            'vite v' + rI(3,6) + '.' + rI(0,9) + '.' + rI(0,9) + ' building for production...',
            '  transforming... (' + rI(50,800) + ')',
            'dist/assets/index-' + rH(8) + '.js  ' + rI(50,800) + '.' + rI(0,9) + 'kB | gzip: ' + rI(10,200) + '.' + rI(0,9) + 'kB',
            'built in ' + rI(1,120) + 'ms',
          ];
        },

        /* 3: cargo build */
        function() {
          return [
            '$ cargo build --release',
            '   Compiling ' + pick(['proc-macro2','quote','syn','serde','tokio','hyper','reqwest']) + ' v' + rI(1,4) + '.' + rI(0,15) + '.' + rI(0,9),
            '   Compiling ' + pick(['tracing','anyhow','thiserror','clap','axum','tower']) + ' v' + rI(0,3) + '.' + rI(0,15) + '.' + rI(0,9),
            '   Compiling ' + pick(['serde_json','bytes','http','mime','url']) + ' v' + rI(0,3) + '.' + rI(0,15) + '.' + rI(0,9),
            '   Compiling app v0.' + rI(1,9) + '.' + rI(0,15),
            '    Finished release [optimized] target(s) in ' + rI(5,180) + 's',
            '$ ./target/release/app --config /etc/app.toml',
            '[INFO] server listening on 0.0.0.0:' + rPort(),
          ];
        },

        /* 4: error cascade / ECONNREFUSED */
        function() {
          var svc = pick(['postgres','redis','mongodb','elasticsearch','rabbitmq']);
          return [
            'Error: connect ECONNREFUSED 127.0.0.1:' + rPort(),
            '    at TCPConnectWrap.afterConnect [as oncomplete] (net.js:' + rI(100,1400) + ':' + rI(1,30) + ')',
            '    at Object.<anonymous> (/opt/app/db/pool.js:' + rI(1,80) + ':' + rI(1,30) + ')',
            '    at Module._compile (internal/modules/cjs/loader.js:' + rI(900,1400) + ':' + rI(1,30) + ')',
            'Caused by: ' + svc + ' connection pool exhausted (maxPoolSize=' + rI(5,50) + ')',
            'FATAL: unable to acquire connection after ' + rI(1000,30000) + 'ms timeout',
            '[ERROR] shutting down worker pid=' + rPid() + ' exit_code=1',
            'Retrying in ' + rI(1,30) + 's... (attempt ' + rI(1,5) + '/5)',
          ];
        },

        /* 5: kernel dmesg */
        function() {
          return [
            rTs() + ' kernel: Linux version 6.' + rI(1,9) + '.' + rI(0,50) + '-generic',
            rTs() + ' kernel: Command line: BOOT_IMAGE=/vmlinuz root=/dev/sda1',
            rTs() + ' kernel: ACPI: RSDP 0x' + rH(8) + ' 000024 (v02 BOCHS)',
            rTs() + ' kernel: PCI: Using configuration type 1 for base access',
            rTs() + ' kernel: clocksource: tsc-early: mask: 0xffffffffffffffff',
            rTs() + ' kernel: Spectre V2 : Enabling Restricted Speculation',
            rTs() + ' kernel: NET: Registered PF_INET6 protocol family',
            rTs() + ' kernel: EXT4-fs (sda1): mounted filesystem with ordered data mode',
            rTs() + ' kernel: systemd[1]: Detected architecture x86-64',
            rTs() + ' kernel: audit: type=1400 avc:  denied  { read } pid=' + rPid(),
            rTs() + ' kernel: TCP: reno registered',
            rTs() + ' kernel: NET: Registered PF_UNIX/PF_LOCAL protocol family',
          ];
        },

        /* 6: HTTP access log nginx/apache */
        function() {
          var paths = ['/', '/catalog', '/api/v1/items', '/api/v1/session', '/static/app.js',
                       '/static/app.css', '/favicon.ico', '/health', '/metrics', '/api/v1/auth', '/api/v1/cart'];
          var codes = [200,200,200,200,201,204,301,304,400,401,403,404,500];
          var agents = [
            'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
            'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15',
            'curl/7.81.0',
            'Go-http-client/2.0',
            'python-requests/2.28.0',
          ];
          var lines = [];
          var n = rI(6, 10);
          for (var i = 0; i < n; i++) {
            var code = pick(codes);
            var hh = rI(0,23).toString().padStart(2,'0');
            var mm = rI(0,59).toString().padStart(2,'0');
            var ss = rI(0,59).toString().padStart(2,'0');
            lines.push(rIp() + ' - - [' + rI(1,28) + '/Apr/2026:' + hh + ':' + mm + ':' + ss + ' +0000] "GET ' + pick(paths) + ' HTTP/2.0" ' + code + ' ' + rI(0,99999) + ' "-" "' + pick(agents) + '"');
          }
          return lines;
        },

        /* 7: database query log (postgres) */
        function() {
          var hh = rI(0,23).toString().padStart(2,'0');
          var mm = rI(0,59).toString().padStart(2,'0');
          var ss = rI(0,59).toString().padStart(2,'0');
          var ms = rI(0,999).toString().padStart(3,'0');
          return [
            '2026-04-19 ' + hh + ':' + mm + ':' + ss + '.' + ms + ' UTC [' + rPid() + '] LOG:  connection received: host=' + rIp(),
            'LOG:  execute <unnamed>: SELECT * FROM items WHERE id = $1',
            "DETAIL:  parameters: $1 = '" + rI(1,50) + "'",
            'LOG:  duration: ' + rMs() + '.' + rI(0,999).toString().padStart(3,'0') + ' ms  statement: SELECT count(*) FROM sessions',
            'LOG:  statement: BEGIN',
            'LOG:  execute s1: INSERT INTO events (type,payload,ts) VALUES ($1,$2,NOW())',
            'LOG:  duration: ' + rMs() + '.' + rI(0,999).toString().padStart(3,'0') + ' ms',
            'LOG:  statement: COMMIT',
            'LOG:  autovacuum: VACUUM ANALYZE public.items',
            'LOG:  checkpoint complete: wrote ' + rI(1,999) + ' buffers (' + rF(0,4).toFixed(1) + '%)',
          ];
        },

        /* 8: git operations */
        function() {
          var h1 = rH(7), h2 = rH(7);
          return [
            '$ git pull origin main',
            'remote: Enumerating objects: ' + rI(1,200) + ', done.',
            'remote: Counting objects: 100% (' + rI(1,200) + '/' + rI(1,200) + '), done.',
            'remote: Compressing objects: 100% (' + rI(1,100) + '/' + rI(1,100) + '), done.',
            'Unpacking objects: 100% (' + rI(1,50) + '/' + rI(1,50) + '), ' + rI(1,500) + '.' + rI(0,9) + 'KiB | ' + rI(1,20) + '.' + rI(0,9) + 'MiB/s, done.',
            'From https://github.com/innocences/app',
            '   ' + h1 + '..' + h2 + '  main -> origin/main',
            'Updating ' + h1 + '..' + h2,
            'Fast-forward',
            ' src/components/Drum.js  | ' + rI(1,80) + ' ' + '++++++++++++++++++++++',
            ' src/lib/catalog.js      | ' + rI(1,30) + ' ' + '++++++++++++----',
            ' package.json            |  2 +-',
            rI(1,5) + ' files changed, ' + rI(1,200) + ' insertions(+), ' + rI(0,100) + ' deletions(-)',
          ];
        },

        /* 9: SSH auth / login events */
        function() {
          var t1 = rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0');
          var t2 = rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0');
          var t3 = rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0');
          return [
            'Apr 19 ' + t1 + ' host sshd[' + rPid() + ']: Accepted publickey for op from ' + rIp() + ' port ' + rPort() + ' ssh2',
            'Apr 19 ' + t1 + ' host sshd[' + rPid() + ']: pam_unix(sshd:session): session opened for user op',
            'Apr 19 ' + t2 + ' host sudo: op : TTY=pts/0 ; PWD=/opt/app ; USER=root ; COMMAND=/bin/systemctl restart app',
            'Apr 19 ' + t3 + ' host sshd[' + rPid() + ']: Failed password for invalid user ' + pick(['admin','root','ubuntu','deploy']) + ' from ' + rIp() + ' port ' + rPort() + ' ssh2',
            'Apr 19 ' + t3 + ' host sshd[' + rPid() + ']: Failed password for invalid user ' + pick(['admin','root','ubuntu','deploy']) + ' from ' + rIp() + ' port ' + rPort() + ' ssh2',
            'Apr 19 ' + t3 + ' host sshd[' + rPid() + ']: Disconnecting invalid user: Too many authentication failures',
            'Apr 19 ' + t3 + ' host sudo: pam_unix(sudo:auth): authentication failure; logname=op uid=' + rI(1000,9999),
          ];
        },

        /* 10: cron job output */
        function() {
          var job = pick(['backup.sh','vacuum.py','report.rb','sync.sh','cleanup.js','rotate.sh']);
          return [
            '# CRON 2026-04-19 ' + rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + '  running ' + job,
            '$ /opt/scripts/' + job,
            '[cron] starting job pid=' + rPid(),
            '[cron] connecting to db ' + rIp() + ':5432/prod',
            '[cron] processed ' + rI(0,9999) + ' records in ' + rI(100,30000) + 'ms',
            '[cron] archived ' + rI(1,500) + ' files to s3://backups/2026-04-19/',
            '[cron] purged ' + rI(0,200) + ' expired sessions',
            '[cron] job complete exit=0 duration=' + rI(1,600) + 's',
            '# CRON finished OK',
          ];
        },

        /* 11: docker / container events */
        function() {
          var img = pick(['node:20-alpine','postgres:15','nginx:1.25','redis:7','python:3.11-slim']);
          return [
            '$ docker pull ' + img,
            img + ': Pulling from library/node',
            rH(12) + ': Pull complete',
            rH(12) + ': Pull complete',
            rH(12) + ': Pull complete',
            'Digest: sha256:' + rH(64),
            'Status: Downloaded newer image for ' + img,
            '$ docker run -d --name app-' + rI(1,99) + ' -p ' + rPort() + ':3000 app:latest',
            rH(64),
            '$ docker ps',
            'CONTAINER ID   IMAGE         COMMAND                  STATUS',
            rH(12) + '   app:latest    "node server.js"         Up ' + rI(1,59) + ' seconds',
            rH(12) + '   ' + img + '   "docker-entrypoint.s..."   Up ' + rI(2,60) + ' minutes',
          ];
        },

        /* 12: network packet capture tcpdump */
        function() {
          var port = rPort();
          var t1 = rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + '.' + rI(0,999999).toString().padStart(6,'0');
          var t2 = rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + '.' + rI(0,999999).toString().padStart(6,'0');
          var t3 = rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + '.' + rI(0,999999).toString().padStart(6,'0');
          return [
            '$ tcpdump -i eth0 -n port ' + port + ' -c 20',
            'tcpdump: listening on eth0, link-type EN10MB, capture size 262144 bytes',
            t1 + ' IP ' + rIp() + '.' + port + ' > ' + rIp() + '.' + port + ': Flags [S], seq ' + rI(0,999999999) + ', win 65535, length 0',
            t2 + ' IP ' + rIp() + '.' + port + ' > ' + rIp() + '.' + port + ': Flags [S.], seq ' + rI(0,999999999) + ', ack ' + rI(0,9999999) + ', win 65535',
            t3 + ' IP ' + rIp() + '.' + port + ' > ' + rIp() + '.' + port + ': Flags [.], ack 1, win ' + rI(100,65535) + ', length 0',
            t3 + ' IP ' + rIp() + '.' + port + ' > ' + rIp() + '.' + port + ': Flags [P.], seq 1:' + rI(100,2000) + ', ack 1, length ' + rI(100,2000),
            '20 packets captured',
            '0 packets dropped by kernel',
          ];
        },

        /* 13: memory / vmstat monitor */
        function() {
          return [
            '$ free -h && vmstat 1 3',
            '              total        used        free      shared  buff/cache   available',
            'Mem:           ' + rI(4,128) + 'G        ' + rI(1,60) + 'G        ' + rI(1,32) + 'G        ' + rI(0,4) + 'G        ' + rI(1,32) + 'G        ' + rI(1,32) + 'G',
            'Swap:          ' + rI(0,16) + 'G        ' + rI(0,4) + 'G        ' + rI(0,16) + 'G',
            'procs -----------memory---------- ---swap-- -----io---- -system-- ------cpu-----',
            ' r  b   swpd   free   buff  cache   si   so    bi    bo   in   cs us sy id wa st',
            ' ' + rI(0,9) + '  ' + rI(0,3) + '  ' + rI(0,9999) + '  ' + rI(10000,999999) + '  ' + rI(1000,99999) + ' ' + rI(100000,999999) + '    ' + rI(0,99) + '   ' + rI(0,99) + '  ' + rI(0,9999) + '  ' + rI(0,9999) + ' ' + rI(100,9999) + ' ' + rI(100,9999) + ' ' + rI(0,99) + '  ' + rI(0,30) + '  ' + rI(0,99) + '  ' + rI(0,10) + '  0',
            ' ' + rI(0,9) + '  ' + rI(0,3) + '  ' + rI(0,9999) + '  ' + rI(10000,999999) + '  ' + rI(1000,99999) + ' ' + rI(100000,999999) + '    ' + rI(0,10) + '   ' + rI(0,10) + '   ' + rI(0,999) + '  ' + rI(0,999) + '  ' + rI(100,9999) + ' ' + rI(100,9999) + ' ' + rI(0,99) + '  ' + rI(0,20) + '  ' + rI(0,99) + '  ' + rI(0,5) + '  0',
          ];
        },

        /* 14: grep search */
        function() {
          var term = pick(['ECONNREFUSED','undefined is not','null pointer','FATAL','heap corruption','segfault','timeout','panic','OOM killer']);
          var mod = pick(['auth','catalog','payment','session','worker']);
          return [
            '$ grep -rn "' + term + '" /var/log/ --include="*.log" | tail -20',
            '/var/log/app.log:' + rI(1,9999) + ':2026-04-19 ERROR ' + term + ' in module ' + mod,
            '/var/log/app.log:' + rI(1,9999) + ':  at processNextTick (internal/process/task_queues.js:' + rI(1,300) + ':' + rI(1,30) + ')',
            '/var/log/nginx/error.log:' + rI(1,999) + ': 2026/04/19 ' + rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ' [error] ' + rPid() + '#' + rPid() + ': *' + rI(1,9999) + ' ' + term,
            '/var/log/syslog:' + rI(1,99999) + ':Apr 19 ' + rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0') + ' host kernel: ' + term + ' at ' + rH(8),
            'grep: /var/log/secure: Permission denied',
            rI(3,50) + ' matches across ' + rI(2,8) + ' files',
          ];
        },

        /* 15: curl / http request */
        function() {
          var endpoint = pick(['/api/v1/items','/api/v1/auth','/health','/metrics','/api/v1/cart','/api/v1/session']);
          return [
            '$ curl -sv https://innocences.co' + endpoint + ' -H "Authorization: Bearer eyJ..."',
            '*   Trying ' + rIp() + ':443...',
            '* Connected to innocences.co (' + rIp() + ') port 443 (#0)',
            '* TLSv1.3 (OUT), TLS handshake, Client hello (1)',
            '* TLSv1.3 (IN), TLS handshake, Server hello (2)',
            '* SSL connection using TLSv1.3 / TLS_AES_256_GCM_SHA384',
            '> GET ' + endpoint + ' HTTP/2',
            '> Host: innocences.co',
            '< HTTP/2 200',
            '< content-type: application/json; charset=utf-8',
            '< x-request-id: ' + rH(32),
            '{"status":"ok","ts":' + Date.now() + ',"data":[...]}',
          ];
        },

        /* 16: make / Makefile build */
        function() {
          var target = pick(['all','clean','test','lint','dist','install','deploy']);
          return [
            '$ make ' + target + ' -j' + rI(2,16),
            'cc -O2 -Wall -Wextra -o build/main src/main.c src/util.c src/net.c',
            'cc -O2 -Wall -Wextra -o build/worker src/worker.c src/queue.c',
            'ar rcs build/libapp.a build/main.o build/util.o',
            'ranlib build/libapp.a',
            'ld -o build/app build/main.o build/libapp.a -lssl -lcrypto -lpthread',
            'strip build/app',
            'install -m 755 build/app /usr/local/bin/app',
            "make: Nothing to be done for '" + target + "'.",
          ];
        },

        /* 17: journalctl -f live follow */
        function() {
          var svc = pick(['nginx','postgres','app','redis','sshd','docker']);
          var lines = ['$ journalctl -u ' + svc + '.service -f --no-hostname'];
          var n = rI(6, 11);
          var msgs = {
            nginx:    ['request processing pid=' + rPid(), 'upstream timed out (110: Connection timed out)', 'worker_connections reached', 'client ' + rIp() + ' closed keepalive connection'],
            postgres: ['checkpoint complete: wrote ' + rI(1,500) + ' buffers (' + rF(0,10).toFixed(1) + '%)', 'autovacuum: VACUUM public.items', 'connection received from host=' + rIp() + ' port=' + rPort()],
            app:      ['handled ' + rI(1,200) + ' requests in ' + rMs() + 'ms', 'cache miss ratio: ' + rF(0,30).toFixed(1) + '%', 'queue depth: ' + rI(0,500), 'gc: freed ' + rI(1,500) + 'MB in ' + rMs() + 'ms'],
            redis:    ['Background saving terminated with success', 'Accepted ' + rIp() + ':' + rPort(), rI(0,100) + ' changes in ' + rI(1,300) + 's. Saving...'],
            sshd:     ['Accepted publickey for op from ' + rIp() + ' port ' + rPort() + ' ssh2', 'Failed password for root from ' + rIp(), 'pam_unix: session opened for user op by (uid=0)'],
            docker:   ['container started id=' + rH(12), 'layer ' + rH(12) + ' already cached', 'network bridge created name=app-net-' + rI(1,9)],
          };
          var msgList = msgs[svc] || msgs.app;
          for (var i = 0; i < n; i++) {
            var hh = rI(0,23).toString().padStart(2,'0');
            var mm = rI(0,59).toString().padStart(2,'0');
            var ss = rI(0,59).toString().padStart(2,'0');
            lines.push('Apr 19 ' + hh + ':' + mm + ':' + ss + ' ' + svc + '[' + rPid() + ']: ' + pick(msgList));
          }
          return lines;
        },

        /* 18: Python REPL session */
        function() {
          return [
            'Python 3.' + rI(10,12) + '.' + rI(0,8) + ' (main, Apr ' + rI(1,19) + ' 2026)',
            '[GCC 12.3.0] on linux — Type "help" for more information.',
            '>>> import json, os, hashlib, time',
            '>>> data = json.load(open("/opt/app/catalog.json"))',
            '>>> len(data["items"])',
            String(rI(80,9999)),
            '>>> [d["id"] for d in data["items"][:3]]',
            '[\'' + rH(8) + '\', \'' + rH(8) + '\', \'' + rH(8) + '\']',
            '>>> hashlib.sha256(str(data).encode()).hexdigest()',
            '\'' + rH(64).toLowerCase() + '\'',
            '>>> time.time()',
            String(Math.floor(Date.now() / 1000) + rI(-86400, 0)) + '.' + rI(0,999999),
            '>>> exit()',
          ];
        },

        /* 19: ss open ports / established connections */
        function() {
          var lines = ['$ ss -tulpn'];
          lines.push('Netid  State    Recv-Q Send-Q  Local Address:Port    Peer Address:Port');
          var svcs = [
            ['tcp','LISTEN','0.0.0.0:22',    'sshd'],
            ['tcp','LISTEN','0.0.0.0:80',    'nginx'],
            ['tcp','LISTEN','0.0.0.0:443',   'nginx'],
            ['tcp','LISTEN','127.0.0.1:5432','postgres'],
            ['tcp','LISTEN','127.0.0.1:6379','redis-server'],
            ['tcp','LISTEN','0.0.0.0:3000',  'node'],
          ];
          var n = rI(3, svcs.length);
          for (var i = 0; i < n; i++) {
            var s = svcs[i];
            lines.push(s[0] + '  ' + s[1] + '  0  0  ' + s[2] + '  0.0.0.0:*  users:(("' + s[3] + '",pid=' + rPid() + ',fd=' + rI(3,30) + '))');
          }
          var estab = rI(2, 5);
          for (var j = 0; j < estab; j++) {
            lines.push('tcp  ESTAB  0  0  ' + rIp() + ':443  ' + rIp() + ':' + rI(32000,65535));
          }
          return lines;
        },

        /* 20: iptables firewall rules */
        function() {
          return [
            '$ iptables -L INPUT -n --line-numbers',
            'Chain INPUT (policy DROP)',
            'num  target   prot opt  source               destination',
            '1    ACCEPT   all  --   0.0.0.0/0            0.0.0.0/0  state RELATED,ESTABLISHED',
            '2    ACCEPT   tcp  --   0.0.0.0/0            0.0.0.0/0  dpt:22',
            '3    ACCEPT   tcp  --   0.0.0.0/0            0.0.0.0/0  dpt:443',
            '4    DROP     tcp  --   ' + rIp() + '    0.0.0.0/0  /* brute-force block */',
            '5    DROP     tcp  --   ' + rIp() + '    0.0.0.0/0  /* brute-force block */',
            '6    LOG      all  --   0.0.0.0/0            0.0.0.0/0  LOG prefix "IPT_DROP "',
            '7    DROP     all  --   0.0.0.0/0            0.0.0.0/0',
            '$ iptables -L -n | grep -c DROP',
            String(rI(3, 28)),
          ];
        },

        /* 21: OOM killer / kernel memory panic */
        function() {
          var pid = rPid(), comm = pick(['node','postgres','redis','nginx','python']);
          return [
            rTs() + ' kernel: Out of memory: Kill process ' + pid + ' (' + comm + ') score ' + rI(600,999) + ' or sacrifice child',
            rTs() + ' kernel: Killed process ' + pid + ' (' + comm + '), UID 0, total-vm:' + rI(100000,9999999) + 'kB, anon-rss:' + rI(10000,999999) + 'kB',
            rTs() + ' kernel: oom_reaper: reaped process ' + pid + ' (' + comm + '), now anon-rss:0kB, file-rss:0kB',
            rTs() + ' kernel: BUG: soft lockup - CPU#' + rI(0,7) + ' stuck for ' + rI(22,120) + 's! [' + comm + ':' + pid + ']',
            rTs() + ' kernel: Modules linked in: xt_nat ipt_MASQUERADE nf_nat',
            rTs() + ' kernel: CPU: ' + rI(0,7) + ' PID: ' + pid + ' Comm: ' + comm + ' Tainted: G OE',
            rTs() + ' kernel: RIP: 0010:[<ffffffff' + rH(8) + '>] [<ffffffff' + rH(8) + '>] shrink_inactive_list+0x' + rH(3),
            rTs() + ' kernel: Call Trace:',
            rTs() + ' kernel:  [<ffffffff' + rH(8) + '>] ? shrink_zone+0x' + rH(3),
            rTs() + ' kernel:  [<ffffffff' + rH(8) + '>] ? try_to_free_pages+0x' + rH(3),
            rTs() + ' kernel: ---[ end trace ' + rH(16) + ' ]---',
          ];
        },

        /* 22: segfault / core dump */
        function() {
          var bin = pick(['/opt/app/server','/usr/bin/node','/usr/sbin/nginx','/opt/worker']);
          var sig = pick(['SIGSEGV','SIGABRT','SIGBUS','SIGFPE']);
          return [
            bin + ': ' + sig + ' (core dumped)',
            'Thread ' + rI(1,16) + ' "' + pick(['worker','server','handler','runner']) + '" received signal ' + sig + ', Segmentation fault.',
            '0x00007f' + rH(10) + ' in ?? ()',
            '(gdb) bt',
            '#0  0x00007f' + rH(10) + ' in malloc () from /lib/x86_64-linux-gnu/libc.so.6',
            '#1  0x0000' + rH(12) + ' in ' + pick(['allocBuffer','expandHeap','gc_compact','js_malloc']) + ' ()',
            '#2  0x0000' + rH(12) + ' in ' + pick(['v8::internal::Heap::','uv_run','libuv::loop_','node::Start']) + '() ()',
            '#3  0x0000' + rH(12) + ' in main (argc=' + rI(1,5) + ', argv=0x' + rH(12) + ') at src/main.c:' + rI(1,200),
            'Aborted (core dumped)',
            '[ERROR] process exited unexpectedly — restarting in ' + rI(1,10) + 's',
          ];
        },

        /* 23: crash loop / systemd restart storm */
        function() {
          var svc = pick(['app','worker','api-gateway','auth-service','catalog-service']);
          var lines = [];
          var t = rI(0,23).toString().padStart(2,'0') + ':' + rI(0,59).toString().padStart(2,'0');
          for (var i = 0; i < rI(5,9); i++) {
            var mm = rI(0,59).toString().padStart(2,'0');
            var ss = rI(0,59).toString().padStart(2,'0');
            lines.push('Apr 19 ' + t + ':' + ss + ' host systemd[1]: ' + svc + '.service: Main process exited, code=killed, status=11/SEGV');
            lines.push('Apr 19 ' + t + ':' + ss + ' host systemd[1]: ' + svc + '.service: Failed with result \'signal\'.');
            lines.push('Apr 19 ' + t + ':' + ss + ' host systemd[1]: ' + svc + '.service: Scheduled restart job, restart counter is at ' + (i+1) + '.');
            if (i >= 4) {
              lines.push('Apr 19 ' + t + ':' + ss + ' host systemd[1]: ' + svc + '.service: Start request repeated too quickly.');
              lines.push('Apr 19 ' + t + ':' + ss + ' host systemd[1]: ' + svc + '.service: Failed with result \'start-limit-hit\'.');
              lines.push('Apr 19 ' + t + ':' + ss + ' host systemd[1]: Failed to start ' + svc + '.');
              break;
            }
          }
          return lines;
        },

        /* 24: heap corruption / assertion failure */
        function() {
          var addr = '0x' + rH(12);
          return [
            'FATAL ERROR: ' + pick(['CALL_AND_RETRY_LAST Allocation failed - JavaScript heap out of memory',
              'invalid table size','v8::internal::COUNTER_ID_LIST','Reached heap limit']),
            ' 1: 0x' + rH(12) + ' node::Abort() [node]',
            ' 2: 0x' + rH(12) + ' node::FatalError(char const*, char const*) [node]',
            ' 3: 0x' + rH(12) + ' v8::Utils::ReportOOMFailure [node]',
            ' 4: 0x' + rH(12) + ' v8::internal::V8::FatalProcessOutOfMemory [node]',
            ' 5: 0x' + rH(12) + ' v8::internal::Heap::' + pick(['GarbageCollect','CollectAllGarbage','AllocateRawWith']) + ' [node]',
            '',
            'Writing core dump to: /tmp/core.' + rPid(),
            '',
            'Assertion failed: ' + pick([
              'ptr != nullptr',
              'size <= max_size',
              'refcount > 0',
              'offset + length <= buffer.size()',
              '!queue_.empty()',
            ]) + ', file ' + pick(['src/heap.cc','src/buffer.cc','src/queue.cc','src/net.cc']) + ', line ' + rI(1,800),
            'zsh: abort      ' + pick(['/opt/app/server','/usr/local/bin/node ./index.js','./target/release/app']),
          ];
        },

      ];

      /* ── Pane color palette (warm amber / dim green terminal hues) ── */
      var COLORS = [
        'rgba(160,148,108,',
        'rgba(130,160,100,',
        'rgba(140,155,100,',
        'rgba(110,150,90,',
        'rgba(170,155,100,',
        'rgba(150,145,95,',
        'rgba(120,160,80,',
        'rgba(160,160,90,',
      ];

      /* ── Pane font catalogue — wide size range for visible variance ──
         Weighted so extremes appear but most panes stay readable.
         tiny: 6-8px · small: 9-11px · normal: 12-14px · large: 16-20px · xl: 22-28px */
      var FONTS = [
        /* tiny (rare) */
        { size: 6,  face: 'monospace',               lh: 9  },
        { size: 7,  face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 10 },
        { size: 7,  face: 'monospace',               lh: 10 },
        /* small */
        { size: 8,  face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 12 },
        { size: 9,  face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 13 },
        { size: 9,  face: 'monospace',               lh: 13 },
        { size: 10, face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 14 },
        { size: 10, face: 'monospace',               lh: 14 },
        /* normal (most common — listed 3× for weighting) */
        { size: 11, face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 16 },
        { size: 11, face: 'monospace',               lh: 15 },
        { size: 12, face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 17 },
        { size: 12, face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 17 },
        { size: 13, face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 18 },
        { size: 14, face: 'monospace',               lh: 20 },
        /* large */
        { size: 16, face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 22 },
        { size: 16, face: 'monospace',               lh: 22 },
        { size: 18, face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 25 },
        { size: 20, face: 'monospace',               lh: 27 },
        /* xl (rare) */
        { size: 22, face: 'Mononoki,ui-monospace,"Courier New",monospace', lh: 30 },
        { size: 26, face: 'monospace',               lh: 34 },
      ];

      var W, H, panes, rafId;

      /* ── Load a fresh session into a pane — depth-aware length ── */
      function loadSession(p) {
        var lines = [];
        /* 22% of panes get 2-4 concatenated sessions → significantly longer blocks */
        var repeat = Math.random() < 0.22 ? rI(2, 4) : 1;
        for (var r = 0; r < repeat; r++) {
          var gen = SESSION_TYPES[rI(0, SESSION_TYPES.length - 1)];
          lines = lines.concat(gen());
        }
        var maxChars = Math.max(10, Math.floor(p.maxW / p.charW));
        p.queue      = lines.map(function(l) { return l.slice(0, maxChars); });
        p.lines      = [];
        p.typing     = '';
        p.typingFull = '';
        p.lastCharAt      = 0;
        p.lineDelayUntil  = 0;
        p.outputLineAt    = 0;
        /* state is set by the pausing handler, not here */
      }

      /* ── Build one pane object — depth 0=back 1=mid 2=front ── */
      function makePaneAt(px, py, pw, ph, depth, startPause) {
        var fDef = FONTS[rI(0, FONTS.length - 1)];
        var font = fDef.size + 'px ' + fDef.face;
        ctx.font = font;
        var charW    = ctx.measureText('M').width || fDef.size * 0.6;
        var maxLines = Math.max(3, Math.floor(ph / fDef.lh));

        var opacity, msPerChar, ldMin, ldMax, pMin, pMax, outputMode, scrollMode;

        if (depth === 0) {
          /* back — static snapshot, very dim, refreshes every 60-200 s */
          opacity    = rF(0.004, 0.010);
          outputMode = false;
          msPerChar  = 0;
          ldMin = 0;  ldMax = 0;
          pMin  = 60000; pMax = 200000;
          scrollMode = 0;
        } else if (depth === 1) {
          /* mid — instant line-dump output, medium dim, cycle 12-55 s */
          opacity    = rF(0.010, 0.019);
          outputMode = Math.random() < 0.65; /* 65% output, 35% slow typing */
          /* speed variance: fast burst · normal · slow crawl */
          msPerChar  = pick([rI(6, 18), rI(22, 65), rI(80, 200)]);
          ldMin = 40;   ldMax = 900;
          pMin  = 12000; pMax = 55000;
          scrollMode = pick([0, 0, 0, 1]);
        } else {
          /* front — active typing with cursor, cycle 3-18 s */
          opacity    = rF(0.019, 0.036);
          outputMode = Math.random() < 0.10;
          msPerChar  = pick([rI(4, 10), rI(14, 32), rI(48, 110)]);
          ldMin = pick([5, 15, 80, 300]);
          ldMax = pick([80, 380, 1400, 5500]);
          pMin  = 3000; pMax = 18000;
          scrollMode = pick([0, 0, 0, 1, 2]);
        }

        var pColor = pick(COLORS);
        var p = {
          x: px, y: py, maxW: pw, paneH: ph,
          font: font, lineH: fDef.lh, charW: charW,
          color: pColor,
          opacity: opacity,
          baseStyle: pColor + opacity + ')',  /* pre-cached for hot render path */
          depth: depth,
          outputMode: outputMode,
          lines: [], typing: '', typingFull: '', queue: [],
          state: 'pausing',
          pauseUntil: performance.now() + (startPause || 0),
          msPerChar: msPerChar,
          lineDelayMin: ldMin, lineDelayMax: ldMax,
          pauseMin: pMin, pauseMax: pMax,
          lastCharAt: 0, lineDelayUntil: 0, outputLineAt: 0,
          maxLines: maxLines,
          scrollMode: scrollMode,
          driftX: scrollMode === 2 ? rF(3, 18) : 0,
          cursorOn: true, cursorFlipAt: 0,
        };
        loadSession(p);
        p.state = 'pausing';
        return p;
      }

      /* ── Build pane array — 3-depth layered system, no holes ── */
      function buildPanes() {
        W = canvas.width  = window.innerWidth;
        H = canvas.height = window.innerHeight;
        panes = [];

        /* ── Reduced pane count for perf ────────────────────────────────
           Target ~80-110 on desktop so the render loop stays <1500 fillText
           calls per frame at 60 fps.  Mobile gets ~30-45.                */
        var totalPanes = isTouchDevice
          ? Math.max(30, Math.floor(W * H / 16000))
          : Math.max(80, Math.floor(W * H / 22000));

        /* ── Zone-guaranteed even distribution ───────────────────────────
           Divide the screen into 3 vertical bands (left / center / right).
           Each pane is assigned to a band by its center-x, cycling through
           bands in order so coverage is always balanced even at low counts. */
        var ZONES = [
          { lo: 0,       hi: W * 0.38 },   /* left   */
          { lo: W * 0.31, hi: W * 0.69 },  /* center */
          { lo: W * 0.62, hi: W },          /* right  */
        ];

        for (var i = 0; i < totalPanes; i++) {
          /* depth split: 42% back, 35% mid, 23% front */
          var dr  = Math.random();
          var dep = dr < 0.42 ? 0 : dr < 0.77 ? 1 : 2;

          /* 5-bucket size lottery — produces tiny snippets, tall columns,
             wide slabs etc. all together for an organic look */
          var sT = Math.random();
          var pw, ph;
          if (sT < 0.18) {          /* tiny snippet */
            pw = rI(48, 150);
            ph = rI(26, 80);
          } else if (sT < 0.46) {   /* compact block */
            pw = rI(120, 300);
            ph = rI(65, 220);
          } else if (sT < 0.70) {   /* standard pane */
            pw = rI(230, 440);
            ph = rI(140, 360);
          } else if (sT < 0.87) {   /* tall column */
            pw = rI(140, 300);
            ph = rI(300, 720);
          } else {                   /* wide slab */
            pw = rI(340, 560);
            ph = rI(50, 135);
          }

          /* Assign pane to a zone cycling evenly (i % 3) with ±jitter */
          var zone = ZONES[i % 3];
          /* Center-x of this pane lives inside the zone */
          var halfPw = pw * 0.5;
          var cxMin = zone.lo + halfPw * 0.3;
          var cxMax = zone.hi - halfPw * 0.3;
          if (cxMin > cxMax) { cxMin = zone.lo; cxMax = zone.hi; }
          var cx = rF(cxMin, cxMax);
          var px = cx - halfPw;
          /* Allow slight bleed off-screen edges for natural feel */
          px = Math.max(-pw * 0.20, Math.min(W - pw * 0.80, px));

          /* Fully random vertical position */
          var py = rF(-ph * 0.15, H - ph * 0.85);
          py = Math.max(-ph * 0.20, Math.min(H - ph * 0.80, py));

          /* Stagger: back panes spread over 90 s so they never re-sync */
          var stagger = dep === 0 ? rI(0, 90000)
                      : dep === 1 ? rI(0, 42000)
                      :             rI(0, 18000);

          var pn = makePaneAt(px, py, pw, ph, dep, stagger);
          /* No center opacity penalty — the center already has its own
             product-scroll UI; code behind it is fine at natural opacity */
          panes.push(pn);
        }

        /* Sort panes by font string — minimises ctx.font state changes
           in the hot render loop (font switches are GPU pipeline flushes) */
        panes.sort(function(a, b) {
          return a.font < b.font ? -1 : a.font > b.font ? 1 : 0;
        });
      }

      /* ── Main RAF loop ── */
      var lastTs = null;

      function loop(ts) {
        if (lastTs === null) lastTs = ts;
        var dt = Math.min(ts - lastTs, 50);
        lastTs = ts;

        ctx.clearRect(0, 0, W, H);

        /* Cull expired error-flash panes (reverse splice to keep indices valid) */
        for (var _fi = panes.length - 1; _fi >= 0; _fi--) {
          var _fp = panes[_fi];
          if (_fp.isFlash && _fp.flashExpireAt && ts >= _fp.flashExpireAt) {
            panes.splice(_fi, 1);
          }
        }

        /* Track current font to avoid redundant ctx.font assignments */
        var _curFont = '';

        for (var pi = 0; pi < panes.length; pi++) {
          var p = panes[pi];

          /* Skip panes that are entirely outside the viewport */
          var _pBottom = p.y + (p.lines.length + 1) * p.lineH;
          if (p.y > H || _pBottom < -p.lineH) continue;

          /* horizontal drift mode */
          if (p.scrollMode === 2) {
            p.x += p.driftX * dt / 1000;
            if (p.x > W + 20) p.x = -p.maxW;
          }

          /* cursor blink — independent 530ms toggle */
          if (ts >= p.cursorFlipAt) {
            p.cursorOn = !p.cursorOn;
            p.cursorFlipAt = ts + 530;
          }

          /* ── State machine — depth-aware ── */
          if (p.state === 'pausing') {
            if (ts >= p.pauseUntil) {
              loadSession(p);
              if (p.depth === 0) {
                /* back: dump all lines at once, sit static, re-pause immediately */
                p.lines = p.queue.slice(0, p.maxLines);
                p.queue = [];
                p.state = 'pausing';
                p.pauseUntil = ts + rI(p.pauseMin, p.pauseMax);
              } else if (p.outputMode) {
                /* mid-output: instant line-by-line drop */
                p.state = 'output';
                p.outputLineAt = ts + rI(20, 120);
              } else {
                /* typing: char-by-char with cursor */
                p.state = 'typing';
                p.lastCharAt = ts;
                p.lineDelayUntil = 0;
              }
            }

          } else if (p.state === 'output') {
            /* lines appear instantly, one every 50-250ms — no typing animation */
            if (ts >= p.outputLineAt && p.queue.length > 0) {
              var outLine = p.queue.shift();
              p.lines.push(outLine);
              if (p.lines.length > p.maxLines) p.lines.shift();
              p.outputLineAt = ts + rI(50, 260);
            }
            if (p.queue.length === 0 && ts >= p.outputLineAt) {
              p.state = 'pausing';
              p.pauseUntil = ts + rI(p.pauseMin, p.pauseMax);
            }

          } else if (p.state === 'typing') {
            if (ts >= p.lineDelayUntil) {
              if (p.typingFull === '' && p.queue.length > 0) {
                p.typingFull = p.queue.shift();
                p.typing = '';
                p.lastCharAt = ts;
              }

              if (p.typingFull !== '') {
                var charsToAdd = Math.floor((ts - p.lastCharAt) / p.msPerChar);
                if (charsToAdd > 0) {
                  var newLen = Math.min(p.typingFull.length, p.typing.length + charsToAdd);
                  p.typing = p.typingFull.slice(0, newLen);
                  p.lastCharAt = ts;
                }

                if (p.typing.length >= p.typingFull.length) {
                  p.lines.push(p.typingFull);
                  if (p.lines.length > p.maxLines) p.lines.shift();
                  p.typing = '';
                  p.typingFull = '';

                  if (p.queue.length === 0) {
                    p.state = 'pausing';
                    p.pauseUntil = ts + rI(p.pauseMin, p.pauseMax);
                  } else {
                    p.lineDelayUntil = ts + rI(p.lineDelayMin, p.lineDelayMax);
                  }
                }
              }
            }
          }

          /* ── Render pane ── */
          /* Only switch font when it actually changes (font change = GPU flush) */
          if (p.font !== _curFont) { ctx.font = p.font; _curFont = p.font; }
          var col = p.color;
          var baseOp = p.opacity;

          for (var li = 0; li < p.lines.length; li++) {
            var lineY = p.y + (li + 1) * p.lineH;
            if (lineY < -p.lineH || lineY > H + p.lineH) continue; /* off-screen line */
            /* Fast path: no edge fade needed for the vast majority of lines */
            if (lineY >= 40 && lineY <= H - 30) {
              ctx.fillStyle = p.baseStyle;
              ctx.fillText(p.lines[li], p.x, lineY);
            } else {
              var fade = lineY < 40
                ? Math.max(0, lineY / 40)
                : Math.max(0, (H - lineY) / 30);
              var op = baseOp * fade;
              if (op < 0.003) continue;
              ctx.fillStyle = col + op + ')';
              ctx.fillText(p.lines[li], p.x, lineY);
            }
          }

          /* cursor only on front-layer typing panes (depth 2, or depth 1 typing) */
          if (p.depth >= 1 && p.state === 'typing' && (p.typing !== '' || p.typingFull !== '')) {
            var tY = p.y + (p.lines.length + 1) * p.lineH;
            var tFade = 1;
            if (tY < 40) tFade = Math.max(0, tY / 40);
            if (tY > H - 30) tFade = Math.max(0, (H - tY) / 30);
            var tOp = baseOp * tFade;
            if (tOp >= 0.003) {
              ctx.fillStyle = col + tOp + ')';
              ctx.fillText(p.typing + (p.cursorOn ? '\u2588' : ''), p.x, tY);
            }
          } else if (p.depth === 2 && p.state === 'pausing' && p.lines.length > 0 && p.cursorOn) {
            /* blinking cursor after front-layer session ends */
            var pY = p.y + (p.lines.length + 1) * p.lineH;
            var pFade = 1;
            if (pY < 40) pFade = Math.max(0, pY / 40);
            if (pY > H - 30) pFade = Math.max(0, (H - pY) / 30);
            var pOp = baseOp * 0.7 * pFade;
            if (pOp >= 0.003) {
              ctx.fillStyle = col + pOp + ')';
              ctx.fillText('\u2588', p.x, pY);
            }
          }
        }

        rafId = requestAnimationFrame(loop);
      }

      /* Defer heavy pane build until after boot fade so it doesn't block
         the boot typewriter's setTimeout callbacks during page load */
      function startRain() {
        buildPanes();
        window.addEventListener('resize', function() {
          if (rafId) cancelAnimationFrame(rafId);
          buildPanes();
          lastTs = null;
          rafId = requestAnimationFrame(loop);
        }, { passive: true });
        rafId = requestAnimationFrame(loop);
      }

      /* ── Error flash spawner ─────────────────────────────────────────────
         Randomly injects bright reddish error panes on a timer.
         They auto-expire and are culled by the render loop.           ── */
      var _ERR_FLASH_IDX = [4, 14, 21, 22, 23, 24];

      function spawnErrorFlash() {
        if (!panes || panes.length === 0) return;
        var now = performance.now();
        var count = rI(1, 3);
        for (var _ei = 0; _ei < count; _ei++) {
          var epw = isTouchDevice ? rI(160, 320) : rI(190, 530);
          var eph = isTouchDevice ? rI(100, 240) : rI(130, 500);
          var epx = rF(20, Math.max(20, W - epw - 20));
          var epy = rF(20, Math.max(20, H - eph - 20));

          var ep = makePaneAt(epx, epy, epw, eph, 1, 0);

          /* override to error-tinted color + higher opacity */
          ep.isFlash      = true;
          ep.flashExpireAt = now + rI(3500, 9500);
          ep.color        = 'rgba(200,70,50,';
          ep.opacity      = rF(0.060, 0.135);
          ep.baseStyle    = ep.color + ep.opacity + ')'; /* update cached style */

          /* load one of the error session types */
          var gen = SESSION_TYPES[_ERR_FLASH_IDX[rI(0, _ERR_FLASH_IDX.length - 1)]];
          var lines = gen ? gen() : SESSION_TYPES[rI(0, SESSION_TYPES.length - 1)]();
          var maxChars = Math.max(10, Math.floor(ep.maxW / ep.charW));
          ep.queue        = lines.map(function(l){ return l.slice(0, maxChars); });
          ep.lines        = [];
          ep.typing       = '';
          ep.typingFull   = '';
          ep.lastCharAt   = 0;
          ep.lineDelayUntil = 0;
          ep.outputLineAt = now;
          ep.outputMode   = true;
          ep.state        = 'output';

          panes.push(ep);
        }
        /* schedule next flash burst: 9–30 seconds */
        setTimeout(spawnErrorFlash, rI(9000, 30000));
      }

      /* If the boot screen is still visible, wait for it; otherwise start now */
      if (waitForBoot) {
        var bootEl = document.getElementById('bios-boot');
        if (bootEl && !bootEl.classList.contains('is-fading') && bootEl.style.display !== 'none') {
          var _rainObserver = new MutationObserver(function(muts) {
            muts.forEach(function(m) {
              if (m.type === 'attributes') {
                var b = document.getElementById('bios-boot');
                if (!b || b.style.display === 'none' || b.classList.contains('is-fading')) {
                  _rainObserver.disconnect();
                  startRain();
                  /* first flash fires 12–25 s after boot, then self-schedules */
                  setTimeout(spawnErrorFlash, rI(12000, 25000));
                }
              }
            });
          });
          _rainObserver.observe(bootEl, { attributes: true, attributeFilter: ['class','style'] });
        } else {
          startRain();
          setTimeout(spawnErrorFlash, rI(12000, 25000));
        }
      } else {
        startRain();
      }
  }
  /* Portal now shares main-page background canvases — no separate portal coderain.
     Boot wait is disabled (false) so the main coderain animates immediately
     behind the portal/boot screens. */
  initCodeRain(document.getElementById('bios-coderain'), false);

  /* ── Full-screen Matrix binary rain — portal overlay ── */
  (function initMatrixRain() {
    var canvas = document.getElementById('bios-portal-rainoverlay');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var W, H, cols, drops;
    var CELL = 13;

    function resize() {
      W = canvas.width  = window.innerWidth;
      H = canvas.height = window.innerHeight;
      cols = Math.floor(W / CELL);
      if (!drops) {
        drops = [];
        for (var i = 0; i < cols; i++) drops[i] = -(Math.random() * (H / CELL));
      }
      while (drops.length < cols) drops.push(-(Math.random() * (H / CELL)));
    }
    resize();
    window.addEventListener('resize', resize, { passive: true });

    function draw() {
      requestAnimationFrame(draw);
      ctx.fillStyle = 'rgba(12,11,9,0.10)';
      ctx.fillRect(0, 0, W, H);
      ctx.font = 'bold ' + CELL + 'px Mononoki,ui-monospace,"Courier New",monospace';
      ctx.textBaseline = 'top';
      for (var i = 0; i < cols; i++) {
        var y = drops[i] * CELL;
        if (y >= 0 && y < H) {
          ctx.fillStyle = 'rgba(210,204,190,0.88)';
          ctx.fillText(Math.random() < 0.5 ? '1' : '0', i * CELL, y);
          if (drops[i] > 1) {
            ctx.fillStyle = 'rgba(110,105,95,0.42)';
            ctx.fillText(Math.random() < 0.5 ? '1' : '0', i * CELL, (drops[i] - 1) * CELL);
          }
          if (drops[i] > 3) {
            ctx.fillStyle = 'rgba(55,52,46,0.22)';
            ctx.fillText(Math.random() < 0.5 ? '1' : '0', i * CELL, (drops[i] - 3) * CELL);
          }
        }
        if (y > H && Math.random() > 0.976) drops[i] = 0;
        drops[i] += 0.38 + Math.random() * 0.32;
      }
    }
    draw();
  })();

  /* ── Datamosh: MPEG macroblock artifact overlay during screen transitions ── */
  window.datamosh = function datamosh() {
    var dm = document.createElement('canvas');
    dm.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;z-index:9992;pointer-events:none;';
    var W = dm.width  = window.innerWidth;
    var H = dm.height = window.innerHeight;
    document.body.appendChild(dm);
    var cx = dm.getContext('2d');
    var frames = 0, MAX = 22;

    function dmFrame() {
      cx.clearRect(0, 0, W, H);
      /* macroblocks — shifted color planes */
      var blocks = 5 + Math.floor(Math.random() * 9);
      for (var i = 0; i < blocks; i++) {
        var bw = 40 + Math.random() * 240;
        var bh = 10 + Math.random() * 40;
        var bx = Math.random() * W;
        var by = Math.random() * H;
        var luma = 120 + Math.floor(Math.random() * 80);
        cx.fillStyle = 'rgba(' + luma + ',' + Math.floor(luma * 0.91) + ',' + Math.floor(luma * 0.74) + ',' + (0.03 + Math.random() * 0.09) + ')';
        cx.fillRect(bx, by, bw, bh);
      }
      /* horizontal scan tears */
      var tears = 1 + Math.floor(Math.random() * 4);
      for (var j = 0; j < tears; j++) {
        var ty = Math.random() * H;
        cx.fillStyle = 'rgba(190,185,165,' + (0.02 + Math.random() * 0.06) + ')';
        cx.fillRect(0, ty, W, 1 + Math.floor(Math.random() * 3));
      }
      /* occasional full-frame flash */
      if (Math.random() < 0.18) {
        cx.fillStyle = 'rgba(160,152,130,0.035)';
        cx.fillRect(0, 0, W, H);
      }
      frames++;
      if (frames < MAX) {
        requestAnimationFrame(dmFrame);
      } else {
        var fadeF = 0;
        (function fadeOut() {
          fadeF++;
          dm.style.opacity = String(Math.max(0, 1 - fadeF / 8));
          if (fadeF < 8) requestAnimationFrame(fadeOut);
          else if (dm.parentNode) dm.parentNode.removeChild(dm);
        })();
      }
    }
    requestAnimationFrame(dmFrame);
  }


  /* ── Feature 4: Item number snap ── */
  var numSnapTimer = null;
  searchEl.addEventListener('input', function() {
    clearTimeout(numSnapTimer);
    var val = searchEl.value.trim();
    if (/^\d{1,2}$/.test(val)) {
      var n = parseInt(val, 10);
      if (n >= 1 && n <= items.length) {
        numSnapTimer = setTimeout(function() {
          var target = null;
          for (var k = 0; k < items.length; k++) {
            if (parseInt(items[k].dataset.displayIdx, 10) === n) { target = k; break; }
          }
          if (target !== null) {
            setDrum(target, false);
            updateListProgress();
            showPreview(items[target]);
          }
        }, 500);
      }
    }
  });

  /* ── Feature 5: Deep corruption ── */
  function deepCorruption() {
    var cands = items.filter(function(it) {
      return it.classList.contains('is-loaded') && it !== hoverItem;
    });
    if (!cands.length) { setTimeout(deepCorruption, 28000); return; }
    var victim = cands[Math.floor(Math.random() * cands.length)];
    var nameEl = victim.querySelector('.bios-item-name');
    if (!nameEl || nameEl.classList.contains('is-typing')) { setTimeout(deepCorruption, 5000); return; }
    var original = victim.dataset.name || '';
    var end = Date.now() + 900 + Math.random() * 700;
    nameEl.classList.add('is-deep-corrupt');
    (function storm() {
      if (Date.now() >= end) {
        nameEl.textContent = original;
        nameEl.classList.remove('is-deep-corrupt', 'is-glitching');
        setTimeout(deepCorruption, 25000 + Math.random() * 20000);
        return;
      }
      nameEl.textContent = glitchFrame(original, 0.65 + Math.random() * 0.3);
      nameEl.classList.add('is-glitching');
      setTimeout(storm, 38 + Math.floor(Math.random() * 32));
    })();
  }
  setTimeout(deepCorruption, 30000 + Math.random() * 15000);

  /* ── Feature 6: Low-power mode — braille art with shimmer ── */
  var lowpowerEl  = document.getElementById('bios-lowpower');
  var lpArtEl     = document.getElementById('bios-lowpower-art');
  var LP_MS       = 120000; /* idle threshold — 2 minutes */
  var lpTimer     = null;
  var lpActive    = false;
  var _lpShimInt  = null;

  /* Shimmer: occasionally corrupt 1–3 braille chars, restore quickly */
  var _lpOrigArt  = lpArtEl ? lpArtEl.textContent : '';
  var _lpGlyphSet = '⣿⣾⣽⣻⣷⣯⣟⡿⢿⣿⠿⣻⣚⡛⠛⠙⠀'.split('');
  function _lpShimmer() {
    if (!lpActive || !lpArtEl) return;
    var chars = _lpOrigArt.split('');
    var hits  = 1 + Math.floor(Math.random() * 3);
    for (var i = 0; i < hits; i++) {
      var idx = Math.floor(Math.random() * chars.length);
      if (chars[idx] !== '\n') {
        chars[idx] = _lpGlyphSet[Math.floor(Math.random() * _lpGlyphSet.length)];
      }
    }
    lpArtEl.textContent = chars.join('');
    setTimeout(function() { if (lpArtEl && lpActive) lpArtEl.textContent = _lpOrigArt; }, 60 + Math.random() * 120);
  }

  function enterLowPower() {
    if (lpActive) return;
    lpActive = true;
    try { if (window.BiosAudio) window.BiosAudio.lowPowerEnter(); } catch (_) {}
    /* Drive the IDLE mm:ss footer clock. Resets on enter so each idle
       session counts from zero. */
    (function () {
      var lpClock = document.getElementById('bios-lowpower-clock');
      if (!lpClock) return;
      var enteredAt = Date.now();
      lpClock.textContent = '00:00';
      clearInterval(window._lpClockInt);
      window._lpClockInt = setInterval(function () {
        if (!lpActive) { clearInterval(window._lpClockInt); return; }
        var s = Math.floor((Date.now() - enteredAt) / 1000);
        var m = Math.floor(s / 60);
        lpClock.textContent = String(m).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      }, 1000);
    })();
    if (lpArtEl) lpArtEl.textContent = _lpOrigArt;
    if (lowpowerEl) { lowpowerEl.setAttribute('aria-hidden','false'); lowpowerEl.classList.add('is-active'); }
    _lpShimInt = setInterval(_lpShimmer, 1800 + Math.random() * 2200);
  }
  function exitLowPower() {
    if (!lpActive) return;
    lpActive = false;
    try { if (window.BiosAudio) window.BiosAudio.lowPowerExit(); } catch (_) {}
    clearInterval(_lpShimInt);
    if (lpArtEl) lpArtEl.textContent = _lpOrigArt;
    if (lowpowerEl) { lowpowerEl.setAttribute('aria-hidden','true'); lowpowerEl.classList.remove('is-active'); }
    clearTimeout(lpTimer);
    lpTimer = setTimeout(enterLowPower, LP_MS);
  }
  /* Reset the idle countdown on ANY user input. Previously
     `exitLowPower` was the only listener — but it bails when lpActive
     is false, which meant the initial 2-minute timer kept counting
     down even while the user was actively browsing, and low-power
     would trigger after exactly 2 minutes of page load regardless of
     activity. Now any input resets the timer; lowpower only fires
     after a true 2-minute idle window. */
  function resetLpTimer() {
    clearTimeout(lpTimer);
    lpTimer = setTimeout(enterLowPower, LP_MS);
    if (lpActive) exitLowPower();
  }
  ['mousemove','keydown','wheel','touchstart','click','scroll'].forEach(function(ev) {
    document.addEventListener(ev, resetLpTimer, { passive: true });
  });
  lpTimer = setTimeout(enterLowPower, LP_MS);

  /* ────────────────────────────────────────────────────────────────────
     #7 Hex address column — every item gets a fake memory address
     ──────────────────────────────────────────────────────────────────── */
  (function assignHexAddresses() {
    /* deterministic per session — keeps address stable across re-renders
       and consistent across clones (derived from displayIdx, not DOM position) */
    var basePage = (parseInt(SID.slice(-4), 16) || 0x7F00) & 0xFFFF;
    items.forEach(function(item) {
      var i   = parseInt(item.dataset.displayIdx || '1', 10) - 1;
      var seg = (basePage + (i * 0x40)).toString(16).toUpperCase().padStart(4, '0');
      var off = ((i * 0x28) & 0xFFFF).toString(16).toUpperCase().padStart(4, '0');
      var el  = item.querySelector('.bios-item-addr');
      if (el) el.textContent = '0x' + seg + ':' + off;
    });
  })();

  /* ────────────────────────────────────────────────────────────────────
     #11 [SEEN] tag — show when sessionStorage has a last_<handle> entry
     ──────────────────────────────────────────────────────────────────── */
  function updateSeenTags() {
    items.forEach(function(item) {
      var handle = item.dataset.handle;
      if (!handle) return;
      var seen = !!sessionStorage.getItem('last_' + handle);
      item.classList.toggle('has-seen-tag', seen);
    });
  }
  setInterval(updateSeenTags, 1000);
  updateSeenTags();

  /* ────────────────────────────────────────────────────────────────────
     #9 Breadcrumb — file path reflects active item
     ──────────────────────────────────────────────────────────────────── */
  var breadcrumbEl = document.getElementById('bios-breadcrumb');
  function updateBreadcrumb() {
    if (!breadcrumbEl) return;
    var it = hoverItem || items[activeIdx];
    if (!it) { breadcrumbEl.textContent = 'C:\\FLAWED\\CATALOG\\'; return; }
    var idx   = String(it.dataset.displayIdx || '00').padStart(2, '0');
    var slug  = (it.dataset.handle || 'item').toUpperCase().replace(/[^A-Z0-9]+/g, '_').slice(0, 22);
    breadcrumbEl.textContent = 'C:\\FLAWED\\CATALOG\\' + slug + '_' + idx + '.DAT';
  }
  setInterval(updateBreadcrumb, 250);
  updateBreadcrumb();

  /* ────────────────────────────────────────────────────────────────────
     #1 Session telemetry — uptime, key count, scroll count, idle timer
     ──────────────────────────────────────────────────────────────────── */
  var sessStart   = Date.now();
  var keyCount    = 0;
  var scrollCount = 0;
  var lastInputAt = Date.now();

  function fmtDur(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60);   s -= m * 60;
    return String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
  }
  /* SESSION counter — the only telemetry item kept in the manifest.
     KEYS / SCROLLS / IDLE / DROP removed per design call. The
     keyCount / scrollCount / lastInputAt vars remain in case future
     code wants them, but they're no longer rendered to the DOM. */
  function tickTelemetry() {
    var s = document.getElementById('mfs-session');
    if (s) s.textContent = 'SESSION ' + fmtDur(Date.now() - sessStart);
  }
  setInterval(tickTelemetry, 1000);
  tickTelemetry();

  document.addEventListener('keydown', function() { keyCount++; lastInputAt = Date.now(); }, true);
  document.addEventListener('wheel',   function() { scrollCount++; lastInputAt = Date.now(); }, { passive: true });
  document.addEventListener('mousemove', function() { lastInputAt = Date.now(); }, { passive: true });
  document.addEventListener('click',    function() { lastInputAt = Date.now(); }, { passive: true });

  /* ────────────────────────────────────────────────────────────────────
     #4 Ambient log stream — fake sysadmin log scrolling up the left edge
     ──────────────────────────────────────────────────────────────────── */
  var logEl   = document.getElementById('bios-logstream');
  var LOG_MAX = 22;
  var logBuf  = [];
  function logTime() {
    var d = new Date();
    return String(d.getHours()).padStart(2,'0') + ':' +
           String(d.getMinutes()).padStart(2,'0') + ':' +
           String(d.getSeconds()).padStart(2,'0');
  }
  function logHex(n) {
    return ((Math.random() * 0xFFFF) | 0).toString(16).toUpperCase().padStart(4, '0');
  }
  var LOG_MESSAGES = [
    function() { return 'uplink ping ' + (30 + Math.floor(Math.random() * 80)) + 'ms'; },
    function() { return 'manifest page 0x' + logHex() + ' verified'; },
    function() { return 'memory page 0x' + logHex() + ' reclaimed'; },
    function() { return 'cache hit ratio ' + (70 + Math.floor(Math.random() * 30)) + '%'; },
    function() { return 'item ' + String(Math.floor(Math.random() * MID) + 1).padStart(2,'0') + ' manifest verified'; },
    function() { return 'tty0 idle ' + Math.floor(Math.random() * 60) + 's'; },
    function() { return 'heartbeat seq=' + logHex(); },
    function() { return 'asset stream  ' + (200 + Math.floor(Math.random() * 400)) + 'kB/s'; },
    function() { return 'dma ch' + Math.floor(Math.random() * 8) + ' ack'; },
    function() { return 'kernel: page 0x' + logHex() + ' mapped'; },
    function() { return 'gc: freed ' + (4 + Math.floor(Math.random() * 60)) + 'kB'; },
    function() { return 'scheduler tick (' + (Math.floor(Math.random() * 9999)) + ')'; },
    function() { return 'inv sync 0x' + logHex() + ' \u2192 ok'; },
    function() { return 'fd ' + Math.floor(Math.random() * 255) + ' closed'; },
    function() { return 'route: AS' + (13000 + Math.floor(Math.random() * 2000)) + ' ok'; }
  ];
  function pushLog() {
    if (!logEl) return;
    var line = '[' + logTime() + '] ' + LOG_MESSAGES[Math.floor(Math.random() * LOG_MESSAGES.length)]();
    logBuf.push(line);
    if (logBuf.length > LOG_MAX) logBuf.shift();
    /* newest on top */
    logEl.textContent = logBuf.slice().reverse().join('\n');
    setTimeout(pushLog, 900 + Math.random() * 2400);
  }
  if (logEl) { pushLog(); }

  /* ────────────────────────────────────────────────────────────────────
     #24 Asset / build manifest strip
     ──────────────────────────────────────────────────────────────────── */
  (function initManifest() {
    function pad(n, w) { return String(n).padStart(w, '0'); }
    var now   = new Date();
    var build = now.getFullYear() + '.' + pad(now.getMonth() + 1, 2) + '.' + pad(now.getDate(), 2);
    var nodes = ['AUS-SYD-02', 'AUS-MEL-04', 'USA-IAD-01', 'USA-PDX-03', 'GBR-LHR-05', 'DEU-FRA-07', 'JPN-NRT-02'];
    var node  = nodes[Math.floor(Math.random() * nodes.length)];
    var b = document.getElementById('mfs-build'); if (b) b.textContent = 'BUILD ' + build;
    var n = document.getElementById('mfs-node');  if (n) n.textContent = 'NODE ' + node;

    /* ── CPU% — manifest REV slot driven by scroll progress (set by
       updateListProgress) but labelled CPU so it reads as system load. */
    var cpuEl = document.getElementById('mfs-rev');
    if (cpuEl) cpuEl.textContent = 'CPU   0%';

    /* Manifest DROP countdown removed per design call. The drop timer
       still ticks on the landing portal (#bios-portal-countdown). */

    /* ── UPLINK ms — real ping every 12s, fast jitter display between pings ── */
    var uplinkEl    = document.getElementById('mfs-uplink');
    var baseLatency = 45;
    /* fast fluctuating display — updates every ~350ms */
    (function tickUplink() {
      if (!uplinkEl) return;
      var jitter = (Math.random() - 0.5) * baseLatency * 0.7;
      if (Math.random() < 0.06) jitter += 30 + Math.random() * 80; /* occasional spike */
      var ms = Math.max(1, Math.round(baseLatency + jitter));
      uplinkEl.textContent = 'UPLINK ' + String(ms).padStart(3) + 'ms';
      setTimeout(tickUplink, 300 + Math.random() * 350);
    })();
    /* real ping recalibrates baseLatency */
    (function pingUplink() {
      var t0  = performance.now();
      var img = new Image();
      img.onload = img.onerror = function() {
        baseLatency = Math.max(1, Math.round(performance.now() - t0));
        setTimeout(pingUplink, 12000 + Math.random() * 6000);
      };
      img.src = ((window.__INNOCENCES_ASSETS__ || {}).baseCss || '') + '?_p=' + Date.now();
    })();

    /* ── ELAPSED — session time counter in ms ── */
    (function () {
      var _elapsedEl   = document.getElementById('mfs-elapsed');
      var _sessionStart = Date.now();
      if (!_elapsedEl) return;
      function _fmtElapsed(ms) {
        /* Zero-padded 6-digit ms so character cells don't reflow (with
           tabular-nums on the parent the width is locked). After 60s,
           switch to mm:ss to keep the format compact + still tabular. */
        if (ms < 60000) return 'ELAPSED ' + String(ms).padStart(6, '0') + 'ms';
        var s = Math.floor(ms / 1000);
        var m = Math.floor(s / 60);
        return 'ELAPSED ' + String(m).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      }
      /* 250ms cadence (4 fps) — fast enough to feel live but stops the
         peripheral-vision pulse the 97ms tick used to produce. */
      (function tickElapsed() {
        _elapsedEl.textContent = _fmtElapsed(Date.now() - _sessionStart);
        setTimeout(tickElapsed, 250);
      })();
    })();

    /* [SND] toggle moved out of the manifest strip. The floating
       bios-snd-pip.js now handles SND on every page (catalog
       included) — bottom-right, stacked with the [COOKIES] toggle.
       Pip auto-kicks crtHum() on first gesture if previously
       enabled in localStorage, so no inline handler needed here. */

    /* ── MEM — rapid volatile drift, Task Manager style ── */
    var memEl   = document.getElementById('mfs-mem');
    var memUsed = 140 + Math.random() * 30;
    (function tickMem() {
      if (!memEl) return;
      memUsed += (Math.random() - 0.5) * 14;
      if (Math.random() < 0.06) memUsed += (Math.random() - 0.5) * 35; /* GC spike */
      memUsed = Math.max(72, Math.min(248, memUsed));
      memEl.textContent = 'MEM ' + String(Math.round(memUsed)).padStart(3) + '/256MB';
      setTimeout(tickMem, 350 + Math.random() * 350);
    })();
  })();


  /* ────────────────────────────────────────────────────────────────────
     #13 Price history sparkline — injected into overlay dynamically
     ────────────────────────────────────────────────────────────────────
     Generated deterministically from the product handle so it's stable
     across views but unique per product. Not real price data — flavor. */
  function sparkFromHandle(handle) {
    var CHARS = '\u2581\u2582\u2583\u2584\u2585\u2586\u2587\u2588'; /* ▁▂▃▄▅▆▇█ */
    var h = 0;
    for (var i = 0; i < handle.length; i++) h = ((h << 5) - h + handle.charCodeAt(i)) | 0;
    var out = '';
    for (var j = 0; j < 16; j++) {
      h = (h * 1103515245 + 12345) & 0x7FFFFFFF;
      out += CHARS[(h >> (j * 2)) & 7];
    }
    return out;
  }

  /* ══════════════════════════════════════════════════════════════════════
     FEATURE H — Operator clearance tier (localStorage visit counter)
     GUEST → OBSERVER → CANDIDATE → OPERATOR → ARCHITECT
     ══════════════════════════════════════════════════════════════════════ */
  var CLEARANCE_TIERS = [
    { min: 1,  max: 1,  label: 'GUEST'     },
    { min: 2,  max: 3,  label: 'OBSERVER'  },
    { min: 4,  max: 6,  label: 'CANDIDATE' },
    { min: 7,  max: 12, label: 'OPERATOR'  },
    { min: 13, max: Infinity, label: 'GUEST'      }
  ];
  /* Tier label stored at scope so IP fetch can combine both */
  var _biosTierLabel = 'GUEST';
  (function initClearance() {
    var visits = parseInt(localStorage.getItem('bios_visits') || '0', 10) + 1;
    localStorage.setItem('bios_visits', String(visits));
    var tier = CLEARANCE_TIERS[CLEARANCE_TIERS.length - 1];
    for (var t = 0; t < CLEARANCE_TIERS.length; t++) {
      if (visits >= CLEARANCE_TIERS[t].min && visits <= CLEARANCE_TIERS[t].max) {
        tier = CLEARANCE_TIERS[t]; break;
      }
    }
    _biosTierLabel = tier.label;
    /* opEl will be set by the IP fetch below */
  })();

  /* ── Visitor IP — replaces hardcoded OPERATOR name ── */
  (function fetchVisitorIP() {
    var opEl = document.getElementById('bios-operator-val');
    if (!opEl) return;
    fetch('https://api.ipify.org?format=json')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (opEl && d.ip) opEl.textContent = d.ip;
      })
      .catch(function() {
        if (opEl) opEl.textContent = '?.?.?.?';
      });
  })();

  /* ══════════════════════════════════════════════════════════════════════
     FEATURE I — Product classification badge by price tier
     ══════════════════════════════════════════════════════════════════════ */
  (function assignClassifications() {
    /* collect all unique price cents to set relative thresholds */
    var prices = origItems.map(function(it) {
      return parseInt(it.dataset.priceCents || '0', 10);
    }).filter(function(p) { return p > 0 && p !== 999; }).sort(function(a, b) { return a - b; });
    var q1 = prices[Math.floor(prices.length * 0.33)] || 5000;
    var q2 = prices[Math.floor(prices.length * 0.66)] || 15000;
    var q3 = prices[Math.floor(prices.length * 0.85)] || 30000;
    function classify(cents) {
      if (cents === 0)     return { label: '——', cls: '' };
      if (cents <= q1)     return { label: '[UNCLASSIFIED]', cls: 'cls-open'   };
      if (cents <= q2)     return { label: '[RESTRICTED]',   cls: 'cls-res'    };
      if (cents <= q3)     return { label: '[CONFIDENTIAL]', cls: 'cls-conf'   };
      return                      { label: '[SECRET]',       cls: 'cls-secret' };
    }
    items.forEach(function(item) {
      var cents = parseInt(item.dataset.priceCents || '0', 10);
      var c = classify(cents);
      var el = item.querySelector('.bios-item-class');
      if (!el) return;
      el.textContent = c.label;
      if (c.cls) el.classList.add(c.cls);
    });
  })();

  /* ══════════════════════════════════════════════════════════════════════
     FEATURE S — Volume control (+/- keys, updates welcome audio)
     ══════════════════════════════════════════════════════════════════════ */
  var volPct = parseInt(localStorage.getItem('bios_vol') || '10', 10);
  var volEl  = document.getElementById('bios-player-vol-inline');
  function renderVol() {
    var filled = Math.round(volPct / 10);
    var bar    = '\u2588'.repeat(filled) + '\u2591'.repeat(10 - filled);
    var txt    = 'VOL [' + bar + '] ' + String(volPct).padStart(3) + '%';
    if (volEl) volEl.textContent = txt;
    var aud = document.getElementById('bios-welcome');
    if (aud) aud.volume = volPct / 100;
    if (window._biosYtPlayer && typeof window._biosYtPlayer.setVolume === 'function') {
      window._biosYtPlayer.setVolume(volPct);
    }
    localStorage.setItem('bios_vol', String(volPct));
  }
  renderVol();
  /* volume +/- click buttons */
  var _volUp = document.getElementById('bios-vol-up');
  var _volDn = document.getElementById('bios-vol-down');
  if (_volUp) _volUp.addEventListener('click', function() { volPct = Math.min(100, volPct + 5); renderVol(); });
  if (_volDn) _volDn.addEventListener('click', function() { volPct = Math.max(0,   volPct - 5); renderVol(); });
  document.addEventListener('keydown', function(e) {
    if (overlayOpen) return;
    if (document.activeElement === searchEl) return;
    if (e.key === '+' || e.key === '=') {
      volPct = Math.min(100, volPct + 5);
      renderVol(); e.preventDefault();
    } else if (e.key === '-' || e.key === '_') {
      volPct = Math.max(0, volPct - 5);
      renderVol(); e.preventDefault();
    }
  }, true);

  /* ══════════════════════════════════════════════════════════════════════
     FEATURE R — Social-proof log entries (fake recent purchases)
     ══════════════════════════════════════════════════════════════════════ */
  (function scheduleSocialProof() {
    function emit() {
      var candidates = origItems.filter(function(it) {
        return it.dataset.soldOut !== 'true';
      });
      if (!candidates.length) return;
      var item = candidates[Math.floor(Math.random() * candidates.length)];
      var minsAgo = Math.floor(1 + Math.random() * 47);
      var name    = (item.dataset.name || 'ITEM').slice(0, 22);
      /* inject as a styled log entry via the existing logBuf mechanism */
      if (typeof logBuf !== 'undefined' && logEl) {
        logBuf.push('[tx] ' + name + ' sold — ' + minsAgo + ' min ago');
        if (logBuf.length > LOG_MAX) logBuf.shift();
        logEl.textContent = logBuf.slice().reverse().join('\n');
      }
      setTimeout(emit, 60000 + Math.random() * 60000);
    }
    setTimeout(emit, 25000 + Math.random() * 35000);
  })();

  /* ══════════════════════════════════════════════════════════════════════
     FEATURE G — INNOCENCES lore fragments in log stream
     Every 3-5 min a lore line surfaces, sparse and unexpected
     ══════════════════════════════════════════════════════════════════════ */
  var LORE = [
    '[archive] "we built this for the ones who look twice"',
    '[archive] every piece is a signal. you\'re receiving.',
    '[archive] the catalog is not a store. it is a record.',
    '[archive] innocences — what you carry before you know you carry it.',
    '[archive] frequency: unknown. receiver: you.',
    '[archive] some items do not sell. they wait.',
    '[archive] this interface was not designed. it was remembered.',
    '[archive] the operator leaves no trace. only the session id.'
  ];
  var loreSeq = 0;
  (function scheduleLore() {
    setTimeout(function() {
      if (typeof logBuf !== 'undefined' && logEl) {
        var msg = LORE[loreSeq % LORE.length];
        loreSeq++;
        logBuf.push(msg);
        if (logBuf.length > LOG_MAX) logBuf.shift();
        logEl.textContent = logBuf.slice().reverse().join('\n');
      }
      scheduleLore();
    }, 180000 + Math.random() * 120000); /* 3-5 min */
  })();

  /* ══════════════════════════════════════════════════════════════════════
     FEATURE J — Redacted desc reveal in overlay
     Overlay desc lines show ██████ blocks then un-redact char by char
     ══════════════════════════════════════════════════════════════════════ */
  /* We patch the overlay's nextLine loop to intercept DESC rows */
  /* Desc redact-then-reveal animation on overlay open */
  var _overlayDescRevealTimer = null;
  function revealOverlayDesc() {
    var descEl = document.getElementById('bios-ov-desc');
    if (!descEl || !descEl.textContent) return;
    var original = descEl.textContent;
    var redacted = original.replace(/[\u0020-\u007E\u00A0-\u024F]/g, '\u2588');
    descEl.textContent = redacted;
    descEl.classList.add('bios-overlay-redacted');
    var pos = 0;
    (function reveal() {
      if (pos >= original.length) { descEl.classList.remove('bios-overlay-redacted'); return; }
      descEl.textContent = original.slice(0, pos) + redacted.slice(pos);
      pos += Math.floor(2 + Math.random() * 4);
      setTimeout(reveal, 12 + Math.random() * 10);
    })();
  }

  /* Hook: watch for overlay open, then trigger reveal */
  var _overlayObserver = null;
  if (typeof MutationObserver !== 'undefined' && overlayEl) {
    _overlayObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.target === overlayEl && overlayEl.classList.contains('is-open')) {
          clearTimeout(_overlayDescRevealTimer);
          _overlayDescRevealTimer = setTimeout(revealOverlayDesc, 80);
        }
      });
    });
    _overlayObserver.observe(overlayEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* ── Overlay + low-power: capturing keydown (runs before existing handler) ── */
  document.addEventListener('keydown', function(e) {
    if (lpActive) { return; } /* exitLowPower fires via the passive listener above */
    if (overlayOpen) {
      if (e.key === 'Escape') { closeOverlay(); e.preventDefault(); e.stopPropagation(); return; }
      if (e.key === 'Enter') {
        var t2 = overlayItem || hoverItem || items[activeIdx];
        if (t2 && t2.dataset.url) window.location.href = t2.dataset.url;
        e.preventDefault(); e.stopPropagation(); return;
      }
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); e.stopPropagation(); return; }
      return;
    }
    /* Enter with empty input → open overlay instead of immediate navigate */
    /* Skip if a non-search input (e.g. chat box) has focus */
    var _aeCapt = document.activeElement;
    if (_aeCapt && _aeCapt !== searchEl && (_aeCapt.tagName === 'INPUT' || _aeCapt.tagName === 'TEXTAREA')) return;
    if (e.key === 'Enter' && !searchEl.value.trim()) {
      var fi = hoverItem || items[activeIdx];
      if (fi) { openOverlay(fi); e.preventDefault(); e.stopPropagation(); }
    }
  }, true);

})();

/* Portal + onboarding logic extracted to assets/bios-portal-onboarding.js (256KB limit). */

/* ── Portal shop dropdown toggle ── */
(function () {
  var toggle = document.getElementById('bios-portal-shop-toggle');
  var dd     = document.getElementById('bios-portal-shop-dd');
  if (!toggle || !dd) return;
  function openDd() {
    toggle.setAttribute('aria-expanded', 'true');
    dd.setAttribute('aria-hidden', 'false');
    dd.classList.add('is-open');
    toggle.classList.add('is-active');
    try { if (window.BiosAudio) window.BiosAudio.overlayOpen(); } catch (_) {}
  }
  function closeDd() {
    toggle.setAttribute('aria-expanded', 'false');
    dd.setAttribute('aria-hidden', 'true');
    dd.classList.remove('is-open');
    toggle.classList.remove('is-active');
    try { if (window.BiosAudio) window.BiosAudio.overlayClose(); } catch (_) {}
  }
  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    if (dd.classList.contains('is-open')) closeDd(); else openDd();
  });
  document.addEventListener('click', function (e) {
    if (dd.classList.contains('is-open') && !dd.contains(e.target) && e.target !== toggle) closeDd();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && dd.classList.contains('is-open')) closeDd();
  });
})();

